<template src="./MMP.html"></template>
<style src="./MapManagementPlatform.css"></style>

<script>
// MMP imports
import { mapGetters, mapActions } from 'vuex';
import MMP_HotkeysInfo from './shared/MMP_HotkeysInfo.vue'
import MMP_ExpandableDisplay from './shared/MMP_ExpandableDisplay.vue'
import MMP_ANSI_FeatureTable from './MMP_ANSI/MMP_ANSI_FeatureTable.vue'
import MMP_ANSI_Layers from './MMP_ANSI/MMP_ANSI_Layers.vue'
import MMP_ANSI_Reports from './MMP_ANSI/MMP_ANSI_Reports.vue'
import MMP_ANSI_Testing from './MMP_ANSI/MMP_ANSI_Testing.vue'
import MMP_ANSI_Tools from './MMP_ANSI/MMP_ANSI_Tools.vue'
import MMP_ANSI_UshrStreetView from './MMP_ANSI/MMP_ANSI_UshrStreetView.vue'
import MMP_ANSI_LadybugStreetView from './MMP_ANSI/MMP_ANSI_LadybugStreetView.vue';
import MMP_ANSI_ushrUserSelectANSI from './MMP_ANSI/MMP_ANSI_ushrUserSelectANSI.vue'
import MMP_ANSI_Navigation from './MMP_ANSI/MMP_ANSI_Navigation.vue'
import MMP_ANSI_SpeedLimit from './MMP_ANSI/MMP_ANSI_SpeedLimit.vue'
import MMP_ANSI_LayerShortcuts from './MMP_ANSI/MMP_ANSI_LayerShortcuts.vue'
import MMP_AppLogo from './shared/MMP_AppLogo.vue'
import MMP_Attributes from './shared/MMP_Attributes.vue'
import MMP_Biased_Reports from './MMP_ANSI/MMP_Biased_Reports.vue'
import MMP_ChangePassword from './shared/MMP_ChangePassword.vue'
import MMP_CoordinateInput from './shared/MMP_CoordinateInput.vue'
import MMP_DatasetSelection from './shared/MMP_DatasetSelection.vue'
import MMP_Deliveries from './shared/MMP_Deliveries.vue'
import MMP_DPR from './MMP_DPR/MMP_DPR.vue'
import MMP_DPR_AdminConsole from './MMP_DPR/MMP_DPR_AdminConsole.vue'
import MMP_DPR_EntryManager from './MMP_DPR/MMP_DPR_EntryManager.vue'
import MMP_DPR_Reports from './MMP_DPR/MMP_DPR_Reports.vue'
import MMP_DRT_ErrorControl from './MMP_DRT/MMP_DRT_ErrorControl.vue'
import MMP_DRT_Layers from './MMP_DRT/MMP_DRT_Layers.vue'
import MMP_DRT_ushrUserSelectDRT from './MMP_DRT/MMP_DRT_ushrUserSelectDRT.vue'
import MMP_DPRAutomation from './shared/MMP_DPRAutomation.vue'
import MMP_DisplayClickCoords from './shared/MMP_DisplayClickCoords.vue'
import MMP_FeatureButtons from './shared/MMP_FeatureButtons.vue'
import MMP_FleetioVehicles from './shared/MMP_FleetioVehicles.vue'
import MMP_HDT_AdminConsole from './MMP_HDT/MMP_HDT_AdminConsole.vue'
import MMP_HDT_HardDriveTracking from './MMP_HDT/MMP_HDT_HardDriveTracking.vue'
import MMP_HDT_PointCloud from './MMP_HDT/MMP_HDT_PointCloud.vue'
import MMP_HWDB_Layers from './shared/MMP_HWDB_Layers.vue'
import MMP_HomeButton from './shared/MMP_HomeButton.vue'
import MMP_InactivityWarning from './shared/MMP_InactivityWarning.vue'
import MMP_LatLongToggle from './shared/MMP_LatLongToggle.vue'
import MMP_LayerLegend from './shared/MMP_LayerLegend.vue'
import MMP_LidarTiles from './shared/MMP_LidarTiles.vue'
import MMP_LoadingScreen from './shared/MMP_LoadingScreen.vue'
import MMP_MainMenu from './shared/MMP_MainMenu.vue'
import MMP_MapSettings from './shared/MMP_MapSettings.vue'
import MMP_NewGroupModal from './shared/MMP_NewGroupModal.vue'
import MMP_NewUserModal from './shared/MMP_NewUserModal.vue'
import MMP_ReleaseNotes from './shared/MMP_ReleaseNotes.vue'
import MMP_ScriptAutomation from './shared/MMP_ScriptAutomation.vue'
import MMP_SubNav from './shared/MMP_SubNav.vue'
import MMP_TabNav from './shared/MMP_TabNav.vue'
import MMP_Widgets from './shared/MMP_Widgets.vue'
import MMP_Tools from './shared/MMP_Tools.vue'
import MMP_UpdateUserModal from './shared/MMP_UpdateUserModal.vue'
import MMP_UserAccountControl from './shared/MMP_UserAccountControl.vue'
import MMP_UserProfile from './shared/MMP_UserProfile.vue'
import MMP_WmsSelectModal from './MMP_WMS/MMP_WmsSelectModal.vue'
import MMP_ZoomLevel from './shared/MMP_ZoomLevel.vue'
import MMP_ANSI_NightModeToggle from './MMP_ANSI/MMP_ANSI_NightModeToggle.vue'
import MMP_GTP_TrackingVue from './MMP_GTP/MMP_GTP_Tracking.vue'
import MMP_ImageCarousel from './shared/MMP_ImageCarousel.vue'
import MMP_EODFieldReview from './shared/MMP_EODFieldReview.vue'
import MMP_GTP_Report from './MMP_GTP/MMP_GTP_Report.vue'
import MMP_ANSI_GoogleStreetView from './MMP_ANSI/MMP_ANSI_GoogleStreetView.vue'
import MMP_MainFeatureButtons from './shared/MMP_MainFeatureButtons.vue'
import MMP_ReleaseHistory from './shared/MMP_ReleaseHistory.vue'
import MMP_VersionRelease from './shared/MMP_VersionRelease.vue'
import MMP_Intersection_Testing from './MMP_ANSI/MMP_Intersection_Testing.vue'
import MMP_Intersection_Reports from './MMP_ANSI/MMP_Intersection_Reports.vue'
import MMP_Biased_FeatureTable from './MMP_ANSI/MMP_Biased_FeatureTable.vue'
import MMP_Analytics_Layers from './Analytics/MMP_Analytics_Layers.vue'
import MMP_Analytics_Upload from './Analytics/MMP_Analytics_Upload.vue'
import MMP_Analytics_MileageSlider from './Analytics/MMP_Analytics_MileageSlider.vue'
import MMP_WCL_Layers from './Analytics/MMP_WCL_Layers.vue'
import MMP_Analytics_ToolBar from './Analytics/MMP_Analytics_ToolBar.vue'
import MMP_AccessControl from './shared/MMP_AccessControl.vue';
// Package imports
import Moveable from 'vue-moveable'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import axios from 'axios'
import { addDays, createLayers, removeCustomLayers } from '../../utils/utils.js'

// OpenLayers imports
import 'ol/ol.css'
import Attribution from 'ol/control/Attribution'
import Map from 'ol/Map'
import View from 'ol/View'
import {
  get as projGet,
  fromLonLat,
  toLonLat,
  transform,
  transformExtent,
  get
} from 'ol/proj'
import { unByKey } from 'ol/Observable'
import { OSM, XYZ } from 'ol/source'
import { Tile as TileLayer } from 'ol/layer'
import { GridLayout, GridItem } from 'vue-grid-layout'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { Style, RegularShape, Fill, Stroke, Text, Circle as CircleStyle } from 'ol/style'
import GeomCircle from 'ol/geom/Circle';
import { MultiLineString, LineString, Circle, Polygon } from 'ol/geom'
import {getLength, getArea, getDistance} from 'ol/sphere'
import { getCenter } from 'ol/extent';   
import Draw from 'ol/interaction/Draw'
import { jwtDecode } from 'jwt-decode';
import MMP_Biased_Testing from './MMP_ANSI/MMP_Biased_Testing.vue'
import MMP_Analytics_Attributes from './Analytics/MMP_Analytics_Attributes.vue'
import MMP_NavBar from './MMP_NavBar.vue'
import MMP_Dashboard from './MMP_Dashboard.vue'
export default {
  name: 'MapManagementPlatform',
  components: {
    MMP_HotkeysInfo,
    MMP_ExpandableDisplay,
    MMP_ANSI_FeatureTable,
    MMP_ANSI_Layers,
    MMP_ANSI_Reports,
    MMP_ANSI_Testing,
    MMP_ANSI_Tools,
    MMP_ANSI_UshrStreetView,
    MMP_ANSI_LadybugStreetView,
    MMP_ANSI_ushrUserSelectANSI,
    MMP_ANSI_Navigation,
    MMP_ANSI_SpeedLimit,
    MMP_ANSI_LayerShortcuts,
    MMP_AppLogo,
    MMP_Attributes,
    MMP_Biased_Reports,
    MMP_ChangePassword,
    MMP_CoordinateInput,
    MMP_DatasetSelection,
    MMP_Deliveries,
    MMP_DPR,
    MMP_DPR_AdminConsole,
    MMP_DPR_EntryManager,
    MMP_DPR_Reports,
    MMP_DRT_ErrorControl,
    MMP_DRT_Layers,
    MMP_DRT_ushrUserSelectDRT,
    MMP_DisplayClickCoords,
    MMP_FeatureButtons,
    MMP_FleetioVehicles,
    MMP_HDT_AdminConsole,
    MMP_HDT_HardDriveTracking,
    MMP_HDT_PointCloud,
    MMP_HWDB_Layers,
    MMP_HomeButton,
    MMP_InactivityWarning,
    MMP_LatLongToggle,
    MMP_LayerLegend,
    MMP_LidarTiles,
    MMP_LoadingScreen,
    MMP_MainMenu,
    MMP_MapSettings,
    MMP_NewGroupModal,
    MMP_NewUserModal,
    MMP_ReleaseNotes,
    MMP_ScriptAutomation,
    MMP_SubNav,
    MMP_TabNav,
    MMP_Widgets,
    MMP_Tools,
    MMP_UpdateUserModal,
    MMP_UserAccountControl,
    MMP_UserProfile,
    MMP_WmsSelectModal,
    Moveable,
    VueBootstrap4Table,
    MMP_ZoomLevel,
    MMP_ANSI_NightModeToggle,
    MMP_DPRAutomation,
    GridLayout,
    GridItem,
    MMP_MainFeatureButtons,
    MMP_ReleaseHistory,
    MMP_VersionRelease,
    MMP_GTP_TrackingVue,
    MMP_ImageCarousel,
    MMP_EODFieldReview,
    MMP_GTP_Report,
    MMP_ANSI_GoogleStreetView,
    MMP_Intersection_Testing,
    MMP_Intersection_Reports,
    MMP_Biased_Testing,
    MMP_Biased_FeatureTable,
    MMP_Analytics_Layers,
    MMP_Analytics_Upload,
    MMP_Analytics_MileageSlider,
    MMP_WCL_Layers,
    MMP_Analytics_ToolBar,
    MMP_Analytics_Attributes,
    MMP_AccessControl,
    MMP_NavBar,
    MMP_Dashboard
  },
  data() {
    return {
      app: 'MapManagementPlatform',
      mapsMode: false,
      clickedCoords: null,
      mapResizeObserver: null,
      user: { org: '', email: '', role: '', test: false, id: null },
      map: null,
      currentDate:
        new Date().getFullYear() +
        '-' +
        (new Date().getMonth() + 1) +
        '-' +
        new Date().getDate(),
      // Profile options menu control
      showFeatureButtons: false,
      projects: [
        { 
          name: 'Acquisitions',
          module_name: 'Acquisitions'
        },
        { 
          name: 'Delivery Review Tool',
          module_name: 'DRT'
        },
        { 
          name: 'ANSI',
          module_name: 'ANSI'
        }
      ],
      layers: [],
      entryManagerRows: [],
      ushrLayersButtonsCtrl: [],
      highwayDBcloudLayersButtonsCtrl: [],
      // Loading screen only shown once during initialization
      showLoadingScreen: true,
      // Home screen has layers, profile, and sub nav on by default
      homeScreenComponents: true,
      // HighwayDBCloud components: layers off by default
      highwayDBcloudComponents: false,
      showLegendsComponent: false,
      fromDate: addDays(new Date(), 0),
      toDate: addDays(new Date(), 0),
      showAttributes: false,
      attribResponse: [],
      olSelectkey: [], // Single-click event object assigned in devices component
      olMapMoveStartKey: null,
      olMapMoveEndKey: null,
      olImageLoadStartKey: null,
      olImageLoadEndKey: null,
      olImageLoadErrorKey: null,
      olTileLoadStartKey: null,
      olTileLoadEndKey: null,
      olTileLoadErrorKey: null,
      updateErrorOnSingleClickEventListener: [],
      addErrorOnSingleClickEventListener: [],
      showRcLegend: false,
      lidarMinZoomAchieved: false,
      cqlFilterEventMessages: null,
      cqlFilterCurrentLocations: null,
      highwayDBcloudSubcategory: [],
      layerResponse: [],
      extentResponse: [],
      highwayDbCloudSelectedLayers: [],
      moveable: {
        draggable: true,
        throttleDrag: 0,
        throttleDragRotate: 0
      },
      mmp_layers: [],
      mmp_layersObj: [],
      isAdmin: false,
      ushrLayersVisible: true,
      subNavVisible: false,
      dprVisible: false,
      drtComponents: false,
      drtLayersButtonsCtrl: [],
      ansiLayersButtonCtrl: [],
      hwdbc_releaseId: 8,
      ushrLayers_releaseId: 25,
      drt_releaseId: 0,
      layerLegend: false,
      zoomControlArr: [],
      attributesName: 'Attributes',
      zoomLevelCap: 16,
      ansiComponent: false,
      nightMode: false,
      showStreetView: false,
      showUshrStreetView: false,
      showLadybugStreetView: false,
      error: false,
      updateError: false,
      errLat: null,
      errLong: null,
      errLayer: null,
      errPointLayer: null,
      org_name: null,
      updateErrorDataSource: {
        comments: '',
        created_date: '',
        created_user: '',
        dataset: '',
        id: -1,
        layer_name: '',
        notes: '',
        project_id: -1,
        severity: '',
        status: '',
        updated_date: '',
        updated_user: '',
        region: '',
        archived_date: ''
      },
      errorsLayerVisibility: false,
      errorsLayer: null,
      errorsLayerLegend: null,
      showCoordinateCard: false,
      googleCoords: null,
      qgisCoords: null,
      ansiTestingVisible: false,
      customerProjectId: null,
      vectorLayer: null,
      mileageVectorLayer: null,
      feature_index: 0,
      features: [],
      // DRT Layers panel is visible by default
      showDrtLayersPanel: true,
      showLidarPanel: false,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      layersListMaxHeight: this.onResize,
      hdtVisible: true,
      showError: true,
      customerName: null,
      legendImgSrc: null,
      selectedDataset: null,
      releases: [],
      ansiReleases: [],
      showDRTLayers: false,
      ansiSelectedSelset: null,
      handleDragDisableIframe: false,
      handleDragDisableUSVImg: false,
      ansiLayerName: null,
      iFrameSrc:
        'https://www.google.com/maps/embed/v1/streetview?key=AIzaSyB_S_ytq7NeTEQmW8E3of_UmefkciIb0nw&location=34.660908,-120.459155&heading=330&pitch=-10&fov=35',
      streetViewSrc1: null,
      streetViewSrc2: null,
      ladybugSrc1: null,
      spinnerManager: [],
      finishedLoadingFlags: [
        false, // [0] Check for when map is finished rendering
        false, // [1] Check for if 1 second loading screen time is over
        false, // [2] Check for if getUser method finished
        false // [3] Check for if createMapObj method finished
      ],
      selectedExtent:
        sessionStorage.Extent != null
          ? JSON.parse(sessionStorage.Extent)
          : 'North America',
      apiUrl: null,
      isUshrUser: false,
      shortTermLayerMemory: [],
      mapLayers: null,
      currentANSIPartNumber: null,
      currentDRTPartNumber: 0,
      ansiSelset: null,
      currentANSISelset: null,
      userId: null,
      showZoomPanel: false,
      queryWindowResponse: [],
      acqlayerResponse: [],
      timeBeforeLogout: 0,
      // 3600 seconds = 60 minutes before forced logout
      timeBeforeLogoutDefault: 3600,
      timeBeforeInactivityWarning: 0,
      // 3000 seconds = 50 minutes before inactivity modal appears
      timeBeforeInactivityWarningDefault: 3000,
      inactivityStartTime: null,
      inactivityWarningShowing: false,
      blurConfig: {
        filter: 'blur(1rem)',
        isBlurred: false,
        opacity: 1,
        transition: 'all .2s linear'
      },
      dprUpdateInfo: null,
      recentLayerFetch: {
        release_id: null,
        store_name: null,
        workspace: null,
        delivery_coverage_store: null,
        partNumber: null
      },
      newGroupAdded: {
        groupAdded: false,
        feedbackHidden: false
      },
      cust_layersObj: [],
      customerLayersButtonsCtrl: [],
      showCustLayer: true,
      zoomEnded: 0,
      persistingLayerFilters: [],
      otonomoFilters: [],
      USVImgStyle: '',
      ladybugSVImgStyle: '',
      ushrImageryAttributeData: null,
      ladybugImageryAttributeData: null,
      ladybugImageryData: {
        assetId: 0,
        currentProcessingIndex: 0,
        processingIndexLocationArray: []
      },
      ushrImageryData: {
        assetId: 0,
        currentProcessingIndex: 0,
        processingIndexLocationArray: []
      },
      // Layout grid system coordinates
      layout: [
        { x: 12, y: 0, w: 1, h: 4, i: '0', name: 'zoom' },
        { x: 12, y: 2, w: 1, h: 4, i: '1', name: 'coordinates' },
        { x: 2, y: 0, w: 2, h: 4, i: '2', name: 'layerLegend' },
        { x: 5, y: 100, w: 3, h: 18, i: '5', name: 'ansiTesting' },
        { x: 12, y: 100, w: 1.25, h: 1.25, i: '7', name: 'featureButtons' },
        { x: 0, y: 0, w: 1, h: 10, i: '10', name: 'mainMenuAndDynamicLayerList' },
        { x: 12, y: 4, w: 1, h: 4, i: '13', name: 'extents' },
        { x: 12, y: 6, w: 1, h: 4, i: '14', name: 'base' },
        { x: 12, y: 8, w: 1, h: 4, i: '15', name: 'lidar-toggle' },
        { x: 8, y: 100, w: 2, h: 1.5, i: '17', name: 'fleetioVehicles' },
        { x: 12, y: 10, w: 1, h: 4, i: '18', name: 'measuringTool-toggle' },
        { x: 10, y: 100, w: 1.25, h: 1.25, i: '19', name: 'homeButton' },
        { x: 1, y: 0, w: 1, h: 1, i: '20', name: 'ANSITools' },
        { x: 10.5, y: 100, w: 0.25, h: 4, i: '21', name: 'latLongToggle' },
      ],
      distinct_lidar: [],
      lidarIsLoading: false,
      lidarMaxHeight: '',
      currentBaseMap: '',
      mainMenuMaxHeight: '',
      layerLegendDimensions: {
        height: 0,
        width: 0
      },
      timeSinceLastLidarFetch: new Date().getTime(),
      olLidarMoveStartKey: null,
      olLidarMoveEndKey: null,
      layerLegendMaxHeight: '',
      getCurrentPositionsInterval: null,
      getTripsInterval: null,
      versionReleaseInfo: null,
      layerLegendName: '',
      layerLegendMinimized: false,
      lidarPanelMinimized: false,
      attributesPanelMinimized: false,
      showMeasuringTool: false,
      layerDefinition: null,
      hdLayerSelected: null,
      ansilayerList: [],
      otonomoSubcountry: null,
      otonomoEditedSubcountry: null,
      otonomoFeatureTableSubcountry: null,
      activeImageryLayer: null,
      resetSequentialErrorButtons: false,
      autoLoadedLidarDateCode: '',
      featureTableLoadingLidar: false,
      intrsectionTestingVisible: false,
      company_extentId: null,
      fullSite: null,
      baseMapsToggle: false,
      showToggle: false,
      pointVectorSource: new VectorSource({}),
      pointFeature: null,
      baseMapsOpen: false,
      extentsOpen: false,
      hotkeysInfoVisible: false,
      company_zoomLevel: 3,
      userRoles: ['Generic User', 'Subaru User', 'GM User', 'Nissan User', 'Rivian User'],
      biasedTestingVisible: false,
      clickedLayerName: null,
      tokenExp: null,
      tokenExpirationInterval: null,
      currentAnsiSegment: null,
      currentModalAnsiSegmentId: null,
      wclLayersButtonsCtrl: [],
      analyticsVisible: false,
      wclVisible: false,
      eodFieldReviewVisible:false,
      poiCircle: null,
      showslider: false,
      showAnalyticsAttributes: false,
      anaAttribResponse: [],
      anaSliderVal: 5,
      isAnaKilo: false ,// default unit is mi,
      gmUsers: [],
      measurement: null,
      zoomLevel: null
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
      if (modalId === 'errorModal') this.clearDRTErrorMarker()
    })
    this.initMapManagementPlatform(this)

    setTimeout(() => {
      /* Temporary workaround to black screen issue that occurs
      10% of the time to select users on application load */
      window.dispatchEvent(new Event('resize'))
      this.finishedLoadingFlags[1] = true
    }, 2000)

    var appIsReady = setInterval(() => {
      this.showLoadingScreen = !this.checkIfAllDoneLoading()

      if (!this.showLoadingScreen) {
        this.map.un('rendercomplete', this.setFirstLoadingFlag)
        this.toggleLayerVisibility('Trips')
        this.toggleLayerVisibility('Current Positions')
        clearInterval(appIsReady)
      }
    }, 250)
  },
  methods: {
    showDashboard() {
      this.reset()
      this.mapsMode = false
      if (this.$refs.mmpNavBar) this.$refs.mmpNavBar.currentPage = 'Dashboard'
    },
    showMap() {
      this.mapsMode = true
      this.$nextTick(() => {
        if (this.map) this.map.updateSize()
      })
    },
    async handleNavAction({ project, showMap: shouldShowMap }) {
      // loadProject() calls reset() first thing, which is what turns off the
      // home screen's Current Positions/Trips layers. Awaiting it here before
      // revealing the map means those layers are already off by the time the
      // map (and the customer-select modal on top of it) becomes visible,
      // instead of the map appearing first and briefly showing them still on.
      await this.loadProject(project)
      if (shouldShowMap) this.showMap()
    },
    ...mapActions(['updateGlobalRole', 'updateGlobalAllowedUserModules']),
    initMapManagementPlatform: async self => {
      // Loads logged-in user's info
      self.finishedLoadingFlags[2] = await self.getUser(self)

      // Creates the map
      self.finishedLoadingFlags[3] = await self.createMapObj(self)

      self.showZoomLevel()
      self.map.getLayers().insertAt(
        0,
        new TileLayer({
          source: new OSM({ crossOrigin: 'anonymous' }),
          name: 'OSM base layer',
          zIndex: 2
        })
      )
      self.currentBaseMap = 'OpenStreetMap'
      await self.getExtent()
      self.$nextTick(() => {
        window.addEventListener('resize', self.onResize)
        window.addEventListener('resize', self.onResizeMainMenuOrDLL)
        // window.addEventListener('resize', self.onResizeLidar)
        window.addEventListener('resize', self.onResizeANSITestingWindow)
        window.addEventListener('keydown', (event) => {
          if (event.key == 'Escape' && !self.homeScreenComponents) {
            self.reset();
          }
        })
      })
    },
    checkIfAllDoneLoading() {
      for (let i in this.finishedLoadingFlags) {
        if (!this.finishedLoadingFlags[i]) {
          // If any flag is false, return false
          return false
        }
      }
      return true
    },
    getExtent() {
      if (sessionStorage.token) {
        /* This API call is made to get the response for extent at
        initialization which we can sort further as required.
        This will reduce the additional trip to the backend. */
        axios
          .get(process.env.API_LOCATION + '/api/users/getAllExtents', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getAllExtents API Call Error: ' + content.errors)
            } else {
              this.extentResponse = []
              content.forEach(element => {
                this.extentResponse.push(element)
              })
              // This function assigns extent to the map for North America
              this.transformExtent(this.extentResponse)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async getCompanyExtent() {
      if (sessionStorage.token) {
        if (this.user.org != null) {
          /* This API call is made to get the response for extent at
          initialization which we can sort further as required.
          This will reduce the additional trip to the backend. */
          await axios
            .get(process.env.API_LOCATION + '/api/users/getCompanyExtent', {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'x-auth-token': sessionStorage.token
              },
              params: {
                company_id: this.user.org
              }
            })
            .then(response => {
              const content = response.data
              if (content.errors) {
                console.log('getCompanyExtent API Call Error: ' + content.errors)
              } else {
                this.company_extentId = content.rows[0].extent_id
                this.company_zoomLevel = content.rows[0].zoomlevel
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('User.org is not set')
        }
      } else {
        console.log('No User Token')
      }
    },
    async transformExtent(extArray) {
      let extentValues = []
      let extentCenter = []
      let arr
      if (this.user.role != 'Generic User') {
        // Sorting of array
        this.selectedExtent =
          sessionStorage.Extent != null
            ? JSON.parse(sessionStorage.Extent)
            : 'North America'

        // Assign customized extent
        switch (sessionStorage.Extent) {
          // REFACTOR -- WEBGIS-2548 -- Commented out unused switch case options
          // REFACTOR SUGGESTION -- WEBGIS-2548 -- Should there be an option for Middle East??
          // case '"North America"':
          // case '"Continental United States"':
          default:
            arr = extArray.filter(e => e.extent_description == 'North America')
            break
          case '"Europe"':
            arr = extArray.filter(e => e.extent_description == 'Europe')
            break
          case '"South Korea"':
            arr = extArray.filter(e => e.extent_description == 'South Korea')
            break
          case '"Japan"':
            arr = extArray.filter(e => e.extent_description == 'Japan')
            break
        }
      } else {
        // REFACTOR SUGGESTION -- WEBGIS-2548 -- Should we set this.selectedExtent = Kuwait here...?
        await this.getCompanyExtent()
        arr = extArray.filter(e => e.id == this.company_extentId)
        this.selectedExtent = extArray.filter(e => e.id == this.company_extentId)[0].extent_description
      }

      // Need to convert the string into array of numbers for passing to the transformExtent function
      arr[0].extent.split(',').forEach(element => {
        extentValues.push(element)
      })
      arr[0].extent_center.split(',').forEach(element => {
        extentCenter.push(element)
      })

      let coord = new transformExtent(
        extentValues,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let center = new transform(
        extentCenter,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let view;

      if (this.user.role != 'Generic User') {
        view = new View({
          extent: coord,
          center: center,
          constrainOnlyCenter: true,
          zoom: 5,
          minZoom: 3,
          multiWorld: true
        })
      } else {
        view = new View({
          extent: coord,
          center: center,
          constrainOnlyCenter: true,
          zoom: this.company_zoomLevel,
          minZoom: 3,
          multiWorld: true
        })
      }

      this.map.setView(view)
      this.showZoomPanel = JSON.parse(sessionStorage.getItem('zoomLevel'))

      if (this.user.role == 'Generic User') {
        this.getGenericCoverageLayer()
      } 
    },
    // Gets the layer accoring to release id from db
    async getLayers(
      release_id,
      store_name,
      workspace,
      delivery_coverage_store,
      partNumber,
      update_selset
    ) {
      // Storing this data to easily swap Ushr Layers on extent change
      this.recentLayerFetch = {
        release_id: release_id,
        store_name: store_name,
        workspace: workspace,
        delivery_coverage_store: delivery_coverage_store,
        partNumber: partNumber
      }
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/layer/release', {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              extent: this.selectedExtent,
              release_id: release_id
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('release API Call Error: ' + content.errors)
            } else {
              const layerLinks = []
              this.drtLayersButtonsCtrl.forEach(layer => {
                this.unloadLayers(layer.name)
              })
              this.ansiLayersButtonCtrl.forEach(layer => {
                this.unloadLayers(layer.name)
                if (layer.positionThreshold) {
                  layer.positionThreshold.forEach(layerName => {
                    this.unloadLayers(layerName)
                  })
                }
                if (layer.typeThreshold) {
                  layer.typeThreshold.forEach(layerName => {
                    this.unloadLayers(layerName)
                  })
                }
              })
              this.ushrLayersButtonsCtrl.forEach(layer => {
                this.unloadLayers(layer.name)
              })
              this.wclLayersButtonsCtrl.forEach(layer => {
                this.unloadLayers(layer.name)
              })
              this.customerLayersButtonsCtrl.forEach(layer => {
                console.log(layer)
                this.unloadLayers(layer.name)
              })
              this.drtLayersButtonsCtrl = []
              this.ansiLayersButtonCtrl = []
              this.highwayDBcloudLayersButtonsCtrl = []
              this.ushrLayersButtonsCtrl = []
              this.wclLayersButtonsCtrl = []
              this.customerLayersButtonsCtrl = []
              this.layerResponse = content
              content
                .filter(e => e.visibility != false)
                .forEach(link => {
                  let linkObj = link.link_object
                  let linkObjLayerGroup = linkObj.info.layer_group
                  // Replaces all underscores with spaces
                  let output = linkObj.name.replace(/_/g, ' ')
                  let objToPush = {
                    name: linkObj.name,
                    zoomControl: linkObj.zoomControl,
                    display_name: output,
                    layer_group: linkObjLayerGroup,
                    minZoom:
                      linkObj.minZoom == undefined ? null : linkObj.minZoom,
                    layer_definition:
                      linkObj.layerDefinition == undefined
                        ? null
                        : linkObj.layerDefinition,
                    fullMap: linkObj.fullMap,
                    typeThreshold: linkObj.typeThreshold == undefined ? null : linkObj.typeThreshold,
                    positionThreshold: linkObj.positionThreshold == undefined ? null : linkObj.positionThreshold,
                    threshold: linkObj.threshold == undefined ? null : linkObj.threshold
                  }
                  linkObj['display_name'] = output
                  /* Render Geoserver WMS layers as 512px tiles (TileWMS512) rather
                  than a single untiled ImageWMS request. Tiled layers load their
                  tiles in parallel and are GeoWebCache-cacheable, so they come in
                  faster and stay sharp. */
                  if (linkObj.layerType === 'ImageWMS') {
                    linkObj.layerType = 'TileWMS512'
                  }
                  layerLinks.push(linkObj)
                  if (linkObjLayerGroup == 'HighwayDBCloud') {
                    let button = {
                      name: linkObj.name,
                      legendURL: linkObj.info.legend_url + '&authkey=' + sessionStorage.token,
                      subcategory: linkObj.info.subcategory,
                      link_object: linkObj
                    }
                    let newOrderedGrouped = []
                    // Push button for HDWDBC layers
                    this.highwayDBcloudLayersButtonsCtrl.push(button)
                    this.highwayDBcloudSubcategory.push(button.subcategory)
                    this.highwayDBcloudSubcategory = [
                      ...new Set(this.highwayDBcloudSubcategory)
                    ]
                    // REFACTOR SUGGESTION -- WEBGIS-2548 -- the below code is in fact not putting the latest delivery at index 0. It is doing the opposite. Subcategories that are undefined
                    //    are being pushed to the front of the array by calling unshift(). 
                    // For loop makes it so the latest delivery is at index 0.
                    for (let heading in this.highwayDBcloudSubcategory) {
                      let head = this.highwayDBcloudSubcategory[heading]
                      if (head == undefined) {
                        newOrderedGrouped.unshift(head)
                      } else {
                        newOrderedGrouped.push(head)
                      }
                    }
                    this.highwayDBcloudSubcategory = newOrderedGrouped
                  }
                  // Push button for DRT layers
                  if (linkObjLayerGroup.includes('DRT')) {
                    this.drtLayersButtonsCtrl.push(objToPush)
                  }
                  // Push button for ANSI layers
                  if (linkObjLayerGroup.includes('ANSI')) {
                    this.ansiLayersButtonCtrl.push(objToPush)
                  }
                  // Push button for WCL and Analtyics Tool layers
                  if (linkObjLayerGroup.includes('WCL')) {
                    // Adding special poi tag to the layer object for POI Uploads
                    //    false: layer wont be visible
                    //    true: layer visible
                    if (objToPush.name == 'POI Uploads') {
                      objToPush['poi'] = true
                    }
                    this.wclLayersButtonsCtrl.push(objToPush)
                  }
                  // Push button for USHR layers
                  if (linkObjLayerGroup == 'USHR') {
                    this.ushrLayersButtonsCtrl.push({
                      name: linkObj.name,
                      legendURL: linkObj.info.legend_url
                    })
                  }
                })

              // Sort ushrLayersButtonsCtrl to keep customer layers together
              this.ushrLayersButtonsCtrl.sort((a, b) =>
                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
              )

              // Validation for formulating url and layers based on the part number and selset selection only for GM ANSI
              layerLinks.forEach(layer => {
                /* If a layer url contains '/wms?' then this step
                can be skipped as it doesn't require url modification. */
                if (
                  layer.info.layer_group == 'GM ANSI' &&
                  !layer.url.includes('/wms?')
                ) {
                  // Following code is for GM ANSI where we are changing the workspace call fumall map layers for biased delivery
                  if (layer.layerDefinition == 'BIASED' && layer.fullMap == true) {
                    layer.params.LAYERS = layer.params.LAYERS.replace(
                      'layer',
                      delivery_coverage_store
                    )
                    layer.url = layer.url + delivery_coverage_store + '/wms?'
                  }
                  else {
                    // layer.url = layer.url + '/wms?'
                    layer.params.LAYERS = layer.params.LAYERS.replace(
                      'layer',
                      store_name
                    )
                    layer.url = layer.url + workspace + '/wms?'
                  }
                }
              })
              this.mmp_layers = layerLinks
              this.mmp_layersObj = createLayers(this.mmp_layers, this.map)
              if (update_selset) {
                this.$refs.ANSI_Tools.updateSelset(partNumber)
              }
            }
            // This if statement allows toggling the layer based on the layer_group
            if (
              this.drtLayersButtonsCtrl.length == 0 &&
              this.ansiLayersButtonCtrl.length == 0
            ) {
              // Hide all the layers on page load for USHR
              this.ushrLayersButtonsCtrl.forEach(layerobj => {
                this.toggleLayerVisibility(layerobj.name)
              })
              // Hide all the layers on page load for HWDB
              this.highwayDBcloudLayersButtonsCtrl.forEach(layerobj => {
                this.toggleLayerVisibility(layerobj.name)
              })
              // Hide all the layers on page load for WCL
              this.wclLayersButtonsCtrl.forEach(layerobj => {
                this.toggleLayerVisibility(layerobj.name)
              })
              // Remove POI Uploads if WCL Mode
              if (this.wclVisible) {
                this.wclLayersButtonsCtrl = this.wclLayersButtonsCtrl.filter((layer) => layer.name != 'POI Uploads')
              }

              if (this.wclVisible || this.analyticsVisible) {
                this.setListeners()
                this.getPOILayerName()
              }
            } else {
              this.drtLayersButtonsCtrl.forEach(layerobj => {
                this.unloadLayers(layerobj.name)
              })
              this.ansiLayersButtonCtrl.forEach(layerobj => {
                this.unloadLayers(layerobj.name)
              })
              new unByKey(this.olMapMoveStartKey)
              new unByKey(this.olMapMoveEndKey)
              this.setListeners()
            }
            this.ansilayerList = this.ansiLayersButtonCtrl
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getPOILayerName() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/analytics/getPOIName/', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            let content = response.data
            const poiLayer = this.wclLayersButtonsCtrl.find(layer => layer.name == 'POI Uploads')
            if (poiLayer && content.length) {
              poiLayer.display_name = content[0].poi_type
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({ name: 'Login' })
      }
    },
    createMapObj: async self => {
      self.map = new Map({
        controls: [new Attribution({ collapsible: true })],
        layers: [],
        target: 'map',
        pixelRatio: 1 // This makes the tiles consistent size and makes caching work better.
      })

      self.map.on('rendercomplete', self.setFirstLoadingFlag)

      const mapEl = document.getElementById('map')
      self.mapResizeObserver = new ResizeObserver(() => {
        self.map?.updateSize()
      })
      self.mapResizeObserver.observe(mapEl)

      self.map.getViewport().addEventListener('contextmenu', evt => {
        evt.preventDefault()
        let coords = toLonLat(self.map.getEventCoordinate(evt, 'EPSG:4326'))
        self.clickedCoords = coords
        self.$refs.tools.$refs.updateClickCoords.showCoords(coords)
      })
      self.mapLayers = self.map.getLayers()
      return Promise.resolve(true)
    },
    setFirstLoadingFlag() {
      // When the map is finished rendering, set the flag to true
      this.finishedLoadingFlags[0] = true
    },
    handleDrag({ target, transform }) {
      target.style.transform = transform
    },
    handleDragStart() {
      this.handleDragDisableIframe = true
      this.handleDragDisableUSVImg = true
    },
    handleDragEnd() {
      this.handleDragDisableIframe = false
      this.handleDragDisableUSVImg = false
    },
    initEntryManager() {
      // Show modal with spinner while API call is loading
      this.$bvModal.show('entryManagerModal')
    },
    initReportConsole() {
      this.$bvModal.show('reportsModal')
    },
    initAdminConsole() {
      this.$bvModal.show('adminConsoleModal')
    },
    initHDTAdminConsole() {
      this.$bvModal.show('hdtAdminConsoleModal')
      this.$refs.hdtAdminConsoleRef.loadAdminConsole()
    },
    initDprModal() {
      // Display DPR Component on edit
      this.$refs.DprRef.updateEntryID = null
      this.$refs.DprRef.clearForm()
      this.$bvModal.show('DPRModal')
    },
    setDprUpdateInfo(e) {
      this.dprUpdateInfo = e
    },
    initWmsModal() {
      this.$bvModal.show('WMSModal')
    },
    async initAnalytics() {
      await this.loadProject('Analytics')
    },
    initWCL() {
      this.loadProject('WCL')
    },
     initDataTool() {
      this.loadProject('DDT')
    },
    initSI() {
      this.loadProject('Spatial_Intelligence')
    },
    initSales() {
      this.loadProject('Sales')
    },
    initDRTErrorManager() {
      this.$bvModal.show('errorManagerModal')
    },
    initDRTNewError() {
      this.$bvModal.show('errorModal')
    },
    initDRTEditError() {
      this.$bvModal.show('editErrorModal')
    },
    initANSIFeatureTable() {
      this.$bvModal.show('featureTableModal')
    },
    initBiasedFeatureTable() {
      this.$bvModal.show('biasedfeatureTableModal')
    },
    getAnsiSelectedSelset(ansiSelectedSelset) {
      this.ansiSelectedSelset = ansiSelectedSelset
    },
    // REFACTOR SUGGESTION -- WEBGIS-2548 -- unused import.
    initANSIReports(ansiSelectedSelset) {
      this.$bvModal.show('reportsANSIModal')
    },
    initBIASEDReports() {
      this.$bvModal.show('reportsBIASEDModal')
    },
    editDprModal(row) {
      // Display data on DPR Component on edit
      this.$refs.DprRef.updateEntryManager(row)
      this.$bvModal.show('DPRModal')
    },
    btnClass(layerName) {
      // Toggle the class for buttons
      let returnClass
      // REFACTORED -- WEBGIS-2548 -- changed from this.map != null to this.map to also account for edge case where this.map = undefined
      if (this.map) {
        // Loop through all layers on map
        if (layerName.includes('base')) {
          this.map.getLayers().forEach(layer => {
            // Check if layer matches layer button
            if (layer.get('name') == layerName) {
              // Assign button class according to visibility
              layer.getVisible()
                ? (returnClass = 'primary')
                : (returnClass = 'dark')
            }
          })
        } else {
          if (this.mmp_layersObj[layerName] != null) {
            const layerobj = this.mmp_layersObj[layerName].layer
            !this.checkLayer(layerobj)
              ? (returnClass = 'dark')
              : (returnClass = 'primary')
          }
        }
      }
      return returnClass
    },
    async loadProject(p, fromInitTool = false) {
      await this.reset();
      switch (p) {
        case 'Daily Productivity Report':
          this.initDprModal()
          break
        case 'HighwayDBCloud':
          // Toggle home screen components off
          this.homeScreenComponents = false
          this.ushrLayersButtonsCtrl.forEach(layer => {
            // Unload ushr layers for HWDB view
            this.unloadLayers(layer.name)
          })
          this.highwayDBcloudComponents = true
          this.getLayers(this.hwdbc_releaseId)
          break
        case 'Delivery Review Tool':
          if (
            this.isUshrUser &&
            !fromInitTool &&
            this.user.role != 'Generic User'
          ) {
            // Fires when selecting DRT from TabNav — always restart customer selection
            this.customerProjectId = null
            this.$bvModal.show('ushrUserSelectDRT')
          }
          if (!this.isUshrUser) {
            this.customerLayersButtonsCtrl.forEach(layer => {
              this.unloadLayers(layer.name)
            })
            this.customerProjectId = sessionStorage.pid
            this.$bvModal.show('datasetSelection')
          }
          if (this.user.role == 'Generic User') {
            // Rendering GM dataset with customer Project Id 21 only for generic users
            this.$bvModal.hide('ushrUserSelectDRT')
            // this.customerProjectId = 21
            // Previous value for this project id was 6 i.e. nissan
          }
          if (this.customerProjectId != null) {
            // Toggle home screen components off
            this.homeScreenComponents = false
            this.ushrLayersButtonsCtrl.forEach(layer => {
              this.unloadLayers(layer.name)
            })
            this.drtComponents = true
            this.$bvModal.hide('ushrUserSelectDRT')
          }
          break
        case 'ANSI':
          if (this.isUshrUser && !fromInitTool) {
            // Fires when selecting ANSI from TabNav — always restart customer selection
            this.customerProjectId = null
            this.$bvModal.show('ushrUserSelectANSI')
          } else {
            // Toggle home screen components off
            this.homeScreenComponents = false
            this.ushrLayersButtonsCtrl.forEach(layer => {
              // Unload ushr layers for HWDB view
              this.unloadLayers(layer.name)
            })
            this.ansiComponent = true
            this.$bvModal.hide('ushrUserSelectANSI')
          }
          break
        case 'Hard Drive Tracking':
          if (this.hdtVisible) {
            this.initHardDriveTracking()
          }
          break
        case 'Analytics':
          this.homeScreenComponents = false;
          this.analyticsVisible = true;
          this.getLayers(57);
          break;
        case 'WCL':
          this.homeScreenComponents = false;
          this.wclVisible = true;
          this.getLayers(57);
          break;
        case 'DDT':
          this.$router.push({ name: 'DataTools' })
          break;
        case 'Spatial_Intelligence':
          this.$router.push({ name: 'Spatial_Intelligence' })
          break;
        case 'Sales':
          this.$router.push({ name: 'Sales'})
          break;
        case 'EodFieldReview' :
            this.homeScreenComponents = false;
            this.ushrLayersButtonsCtrl.forEach(layer => {
                // Unload ushr layers for HWDB view
                this.unloadLayers(layer.name)
              })
            this.eodFieldReviewVisible = true;
            break;

      }
      if (!this.isUshrUser && this.customerLayersButtonsCtrl.length > 0) {
        this.customerLayersButtonsCtrl.forEach(layer => {
          this.map.removeLayer(this.cust_layersObj[layer.name].layer)
        })
      }
    },
    async clearAnalytics() {
      this.clearMeasuringTool();
      this.analyticsVisible = false;
      this.wclVisible = false;
      this.showAnalyticsAttributes = false
      this.anaAttribResponse = null
      this.showslider = false
      this.wclLayersButtonsCtrl.forEach(layer => {
        this.unloadLayers(layer.name)
      })
      if (this.isUshrUser) {
        await this.getLayers(this.ushrLayers_releaseId)
      }
      this.map.removeLayer(this.mileageVectorLayer)
      this.mileageVectorLayer = null
    },
    async clearDRT() {
      this.clearMeasuringTool();
      this.drtLayersButtonsCtrl.forEach(layer => {
        this.unloadLayers(layer.name)
      })
      if (this.isUshrUser && this.user.role != 'Generic User') {
        await this.getLayers(this.ushrLayers_releaseId)
      }
      this.drtComponents = false
      this.layerLegend = false
      if (this.errorsLayerVisibility) {
        this.toggleErrorsLayerVisibility()
      }
      this.customerProjectId = null
      this.$refs.DRTSelectionRef.ushrUserSelectedDRT = null
      this.error = false
      this.removeAddErrorOnClick()
      this.selectedDataset = null
      this.releases = []
      this.showDRTLayers = false
      this.updateError = false
    },
    async clearANSI() {
      this.clearMeasuringTool();
      this.ansiLayersButtonCtrl.forEach(layer => {
        this.unloadLayers(layer.name)
      })
      if (this.isUshrUser) {
        await this.getLayers(this.ushrLayers_releaseId)
      }
      // Remove Otonomo layer from map
      this.map.getLayers().forEach(layer => {
        if (layer.get('name') == 'Otonomo') {
          this.map.removeLayer(layer)
        }
      })
      this.otonomoSubcountry = null
      this.otonomoFeatureTableSubcountry = null
      this.ansiComponent = false
      this.layerLegend = false
      this.loadLegends = false
      this.ansiTestingVisible = false
      this.biasedTestingVisible = false
      this.intrsectionTestingVisible = false
      this.customerProjectId = null
      this.$refs.ANSISelectionRef.ushrUserSelectedANSI = null
      this.currentANSIPartNumber = null
      this.currentAnsiSegment = null
      this.ansiSelectedSelset = null
      this.toggleUSV(false)
      this.toggleLadybugSV(false)
    },
    clearMeasuringTool() {
      // remove interaction for measuring tool
      this.map.getInteractions().forEach(interaction => {
        if (interaction instanceof Draw) {
          interaction.setActive(false)
        }
      })
    },
    clearLidar() {
      // Disables Lidar if it's currently on
      if (this.showLidarPanel) {
        this.toggleLidarPanel()
      }

      this.autoLoadedLidarDateCode = ''
      this.featureTableLoadingLidar = false

      let lidarLayersToRemove = []
      this.map.getLayers().forEach(layer => {
        let layerNameStr = layer.get('name')
          ? layer.get('name').toString()
          : null
        if (layerNameStr && layerNameStr.includes('lidar')) {
          lidarLayersToRemove.push(layer)
        }
      })
      lidarLayersToRemove.forEach(layer => {
        this.map.removeLayer(layer)
      })
      this.distinct_lidar = []
    },
    async clearEodFieldReview() {
      this.eodFieldReviewVisible = false;
      
      if (!this.map) return
     
      removeCustomLayers(this.map, 'eodTracking')
    },
    async reset() {
      switch (true) {
        case (this.analyticsVisible):
        case (this.wclVisible):
          await this.clearAnalytics();
          break;
        case (this.drtComponents):
          await this.clearDRT();
          await this.clearLidar();
          break;
        case (this.ansiComponent):
          await this.clearANSI();
          await this.clearLidar();
        case (this.eodFieldReviewVisible):
          await this.clearEodFieldReview();

          if (this.currentBaseMap === 'Google') {
            this.toggleBaseLayer('OpenStreetMap')
          }
          break;
      }
      this.spinnerManager = []
      this.shortTermLayerMemory = []
      this.persistingLayerFilters = []
      this.homeScreenComponents = true
      this.showAttributes = false
      this.attribResponse = null
      this.showFeatureButtons = false
      this.eodFieldReviewVisible = false
      this.layerLegendDimensions = {
        height: 0,
        width: 0
      }
      this.showMeasuringTool = false
      // Removes circle that appears on map when user inputs coordinates to zoom to
      this.map.removeLayer(this.vectorLayer)
      this.vectorLayer = null
      // Disables the single click event created for Trackslayer on mounting devices component
      new unByKey(this.olSelectkey)
      this.onResizeMainMenuOrDLL()
      this.turnOffHomeScreenLiveLayers()
      this.removeCustomerCoverageLayers()
    },
    // reset() previously (re)loaded the customer's/generic coverage layers
    // here whenever !mapsMode — but reset() runs at the START of every
    // loadProject() call, i.e. while still sitting on the Dashboard
    // (mapsMode is still false at that point, before the destination tool
    // takes over), so this fired on every Dashboard->DRT/ANSI/etc transition
    // and left those layers loaded on the main map underneath the new tool.
    // The main map is hidden the whole time this branch could ever run (it
    // only fires when mapsMode is already false), so there's no visible
    // benefit to loading them here — just remove whatever's currently on the
    // map from any earlier load (e.g. the Generic User layer loaded at
    // initial mount) so it can't bleed into the next tool.
    removeCustomerCoverageLayers() {
      this.customerLayersButtonsCtrl.forEach(layer => {
        const entry = this.cust_layersObj[layer.name]
        if (entry) this.map.removeLayer(entry.layer)
      })
      this.customerLayersButtonsCtrl = []
    },
    // toggleLayerVisibility() genuinely toggles — calling it unconditionally
    // from reset() (as this used to) flips Current Positions/Trips back ON
    // whenever reset() runs while they're already off (e.g. reselecting
    // DRT/ANSI from the nav while already in that tool), instead of just
    // leaving them off. Only toggle when they're actually still on the map.
    turnOffHomeScreenLiveLayers() {
      ['Current Positions', 'Trips'].forEach(name => {
        const entry = this.mmp_layersObj[name]
        if (entry && this.checkLayer(entry.layer)) {
          this.toggleLayerVisibility(name)
        }
      })
    },
    refreshUserModules() {
      this.getUser(this);
    },
    getUser: async self => {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/auth', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            let info = response.data
            let auth = info.authorization
            self.user = {
              email: info.email,
              id: info.id,
              inactive: info.inactive,
              name: info.name,
              org: info.org,
              role: auth.permissions,
              test: auth.testAccount == 'True',
              group: auth.group,
              extent: info.extent_id != null ? info.extent_id : null
            }
            self.isUshrUser = info.org == 1
            self.updateGlobalAllowedUserModules(info.permitted_mmp_modules);
            // REFACTOR SUGGESTION -- WEBGIS-2548 -- self.user.errors is never going to be true here. Self.user is set above
            if (self.user.errors) {
              self.$router.push({ name: 'Login' })
            } else {
              self.getAdmin(info.email)
              self.getReleaseVersion()
            }
            self.checkRoles()
            // REFACTOR SUGGESTION -- WEBGIS-2548 -- self.user is never going to be null here - will at least have an outlined object with null data
            if (self.user != null) {
              self.$refs.ReleaseNotesRef.getVersionRelease(self.user)
            }
            if (self.user.role == 'Generic User') {
              self.getGenericCoverageLayer()
            } else if (!self.isUshrUser) {
              self.getCustomerCoverageLayers()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        self.$router.push({ name: 'Login' })
      }

      return Promise.resolve(true)
    },
    toggleLayerVisibility(layerNameToToggle) {
      if (layerNameToToggle == 'OSM') {
        this.map.getLayers().forEach(layer => {
          if (layer != undefined && layer.get('name') != undefined) {
            if (!layer.get('name').includes('OSM')) {
              this.toggleBaseLayer('OpenStreetMap')
            } else {
              this.toggleBaseLayer('Azure')
            }
          }
        })
      } else {
        if (this.mmp_layersObj.hasOwnProperty(layerNameToToggle)) {
          const layer = this.mmp_layersObj[layerNameToToggle].layer

          // If the layer doesn't exist on the map, add it to the map
          if (!this.checkLayer(layer)) {
            this.toggleLayerVisibilityAddKeyHelper(layer, layerNameToToggle)

            this.map.addLayer(layer)

            if (layerNameToToggle == 'Current Positions') {
              this.currentPositionsLiveUpdate(true)
            }
            if (layerNameToToggle == 'Trips') {
              this.tripsLiveUpdate(true)
            }
            if (layerNameToToggle == 'Otonomo') {
              this.map.getLayers().forEach(layer => {
                // Checks if requested layer name matches
                if (layer.get('name') == 'Otonomo') {
                  let source = layer.getSource()
                  source.updateParams({
                    VIEWPARAMS: `subcountry:${this.otonomoEditedSubcountry};`
                  })
                  source.refresh()
                }
              })
            }
            if (layerNameToToggle == 'Random Intersections') {
              let source = layer.getSource()
              source.updateParams({
                CQL_FILTER: `selset='` + this.currentANSISelset + `'`
              })
              source.refresh()
            }
            if (layerNameToToggle == 'POI Uploads') {
              let source = layer.getSource()
              source.updateParams({
                CQL_FILTER: `region='` + this.selectedExtent + `'`
              })
              source.refresh()
            }
          if (['Added', 'Diverging', 'End of Map', 'Ending', 'Merging', 'Start of Map'].includes(layerNameToToggle)) {
            let biased = this.mmp_layersObj[layerNameToToggle].layer
            biased.getSource().updateParams({
              CQL_FILTER: `part_number='${this.currentANSIPartNumber.part_number}'`
            })
          }
          
            if (this.highwayDBcloudSubcategory.length > 0) {
              this.loadAttributes({
                name: layerNameToToggle,
                layer_group: 'HighwayDBCloud',
                response: this.layerResponse
              }) // Loads attributes for HWDB layer
            }
            if (this.drtComponents || this.ansiComponent) {
              this.getLegend(layerNameToToggle)
            }
          } else {
            this.toggleLayerVisibilityRemoveKeyHelper(layer, layerNameToToggle)
            if (layerNameToToggle == 'Current Positions') {
              this.currentPositionsLiveUpdate(false)
            }
            if (layerNameToToggle == 'Trips') {
              this.tripsLiveUpdate(false)
            }
            // If toggle off POI Uploads, remove circle 
            if (layerNameToToggle == 'POI Uploads') {
              this.map.removeLayer(this.mileageVectorLayer)
              this.mileageVectorLayer = null
            }
          }
          this.onResizeMainMenuOrDLL()
        } else if (this.cust_layersObj.hasOwnProperty(layerNameToToggle)) {
          const layer = this.cust_layersObj[layerNameToToggle].layer

          // If the layer doesn't exist on the map, add it to the map
          if (!this.checkLayer(layer)) {
            this.toggleLayerVisibilityAddKeyHelper(layer, layerNameToToggle)
            this.map.addLayer(layer)
          } else {
            this.toggleLayerVisibilityRemoveKeyHelper(layer, layerNameToToggle)
          }
        }
      }
    },
    toggleLayerVisibilityAddKeyHelper(layer, layerNameToToggle) {
      /* ImageWMS spinner addition and deletion */
      // Add layer to spinnerManager when image loads/refreshes
      this.olImageLoadStartKey = layer
        .getSource()
        .on('imageloadstart', event => {
          this.spinnerManager.push(layerNameToToggle)
        })
      // Remove layer from spinnerManager when image finishes loading
      this.olImageLoadEndKey = layer.getSource().on('imageloadend', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
      // Remove layer from spinnerManager if image encounters a loading error
      // NOTE - Image Load Error has spelling mistake -- should probably check that the correct event (with spelling mistake) is called
      this.olImageLoadErrorKey = layer
        .getSource()
        .on('imageloadeerror', event => {
          let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
          if (layerIndex != -1) {
            this.spinnerManager.splice(layerIndex, 1)
          }
        })

      /* TileWMS spinner addition and deletion */
      // Add layer to spinnerManager when tile loads/refreshes
      this.olTileLoadStartKey = layer.getSource().on('tileloadstart', event => {
        this.spinnerManager.push(layerNameToToggle)
      })
      // Remove layer from spinnerManager when tile finishes loading
      this.olTileLoadEndKey = layer.getSource().on('tileloadend', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
      // Remove layer from spinnerManager if tile encounters a loading error
      this.olTileLoadErrorKey = layer.getSource().on('tileloaderror', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
    },
    toggleLayerVisibilityRemoveKeyHelper(layer, layerNameToToggle) {
      // Removes layer listeners
      new unByKey(this.olImageLoadStartKey)
      new unByKey(this.olImageLoadEndKey)
      new unByKey(this.olImageLoadErrorKey)
      new unByKey(this.olTileLoadStartKey)
      new unByKey(this.olTileLoadEndKey)
      new unByKey(this.olTileLoadErrorKey)
      // Removes layer that has been turned off from spinnerManager
      let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
      while (layerIndex != -1) {
        this.spinnerManager.splice(layerIndex, 1)
        layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
      }
      this.map.removeLayer(layer)
    },
    toggleErrorsLayerVisibility() {
      // Toggles errors layer visibility
      this.errorsLayerVisibility = !this.errorsLayerVisibility
    },
    unloadLayers(layerNameToToggle) {
      let layer
      if (this.mmp_layersObj[layerNameToToggle] != null) {
        layer = this.mmp_layersObj[layerNameToToggle].layer
      } else if (this.cust_layersObj[layerNameToToggle] != null) {
        layer = this.cust_layersObj[layerNameToToggle].layer
      }

      if (layer) {
        // Unloading layer function
        this.map.removeLayer(layer)
        // Removes layer that has been turned off from spinnerManager
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      }
    },
    checkLayer(layer) {
      // Checks if layer exists on the map
      let exists = false
      let mapLayersArr = this.map.getLayers().getArray()

      switch (typeof layer) {
        case 'object':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists = mapLayersArr[i] == layer
            if (exists) {
              break
            }
          }
          break
        case 'string':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists =
              mapLayersArr[i].values_.hasOwnProperty('name') &&
              mapLayersArr[i].values_.name == layer
            if (exists) {
              break
            }
          }
          break
      }

      return exists
    },
    // Loads attributes for all layer
    loadAttributes(attr) {
      let obj = attr.name
      let layer_group = attr.layer_group
      let layerResponse = attr.response
      let layerobj = null
      if (this.mmp_layersObj.hasOwnProperty(obj)) {
        layerobj = layerResponse.filter(c => {
          return (
            c.link_object.info != undefined &&
            c.link_object.info.layer_group == layer_group
          )
        })
      }
      if (layerobj != null) {
        let param = layerobj.filter(c => c.link_object.name == obj)
        if (param.length != 0) {
          /* unByKey function will disable all single-click events
          for layers other than the selected layer */
          new unByKey(this.olSelectkey)
          // This check provides dynamic names to attributes window
          this.attributesName =
            param[0].link_object.params.LAYERS ==
              'mmp:otonomo_selected_subcountry'
              ? `Otonomo ${this.otonomoEditedSubcountry}`
              : param[0].layer_name.replace(/_/g, ' ')
          this.olSelectkey = this.map.on('singleclick', evt => {
            // Analytics Logic: Only query site for information if layer = poi
            // if Analytics && poi: false
            // if Analytics && motorways: true
            // if ANSI / DRT: false
            let analyticsPOI = this.analyticsVisible && (obj != 'POI Uploads') 
            // Get information on the data point that was clicked and single click event is generated only for highwayDBCloud layer
            if (!this.showMeasuringTool && !analyticsPOI) {
              this.resetSequentialErrorButtons = true
              this.querySite(
                evt,
                this.mmp_layersObj[obj].layer,
                this.map,
                param[0].link_object.params.LAYERS
              )
            }
          })
        }
      }
    },
    removeAttributesWindowListener() {
      new unByKey(this.olSelectkey);
      this.olSelectkey = null;
    },
    setOtonomoSubcountryNames(otonomoObj) {
      if (this.mmp_layersObj['Otonomo'] != undefined) {
        this.otonomoSubcountry = otonomoObj.subcountry
        this.otonomoEditedSubcountry = otonomoObj.editedSubcountry
        let minZoom = -1
        let otonomoLayer = this.mmp_layersObj['Otonomo'].layer
        let alreadyOnMap = false
        if (otonomoLayer) {
          minZoom = otonomoLayer.getMinZoom()
        }
        this.map.getLayers().forEach(layer => {
          // Checks if requested layer name matches
          if (layer.get('name') == 'Otonomo') {
            let source = layer.getSource()
            alreadyOnMap = true
            source.updateParams({
              VIEWPARAMS: `subcountry:${this.otonomoEditedSubcountry};`
            })
            source.refresh()
          }
        })
        /* Checks if a subcountry is selected, and that
        the user is at the appropriate zoom level */
        if (
          this.otonomoSubcountry &&
          this.otonomoEditedSubcountry &&
          this.zoomEnded >= minZoom &&
          !alreadyOnMap
        ) {
          /* Automatically toggles the Otonomo layer on
          if a subcountry has been selected */
          this.toggleLayerVisibility('Otonomo')
        }
      }
    },
    changeOtonomoSubcountry(subcountry) {
      this.otonomoFeatureTableSubcountry = new String(subcountry)
    },
    refreshLayer(layerName) {
      // Loop through all layers on map
      this.map.getLayers().forEach(layer => {
        // Check if requested layer matches
        if (layer.get('name') == layerName) {
          // Refresh layer source

          /* This was the old way of forcing a refresh, but then
          it doesn't utilize GeoServer's metatiling which makes
          the layer's styling not always render labels. */
          //layer.getSource().updateParams({TIME: Date.now()})

          layer.getSource().refresh()
        }
      })
    },
    async refreshPOI() {
      await this.pointVectorSource.clear()
      this.map.removeLayer(this.mileageVectorLayer)
      this.map.removeLayer(this.vectorLayer)

      this.mileageVectorLayer = null
      this.vectorLayer = null
      this.showAnalyticsAttributes = false
      this.anaAttribResponse = null

      this.mmp_layersObj['POI Uploads'].layer.getSource().refresh()
      await this.getLayers(57)
    },
    currentPositionsLiveUpdate(bool) {
      // If a current positions interval exists, clear it
      if (this.getCurrentPositionsInterval) {
        this.removeCurrentPositionsInterval()
      }

      /* If turning on the Current Positions layer in the
      Dynamic Layer List, set the interval */
      if (bool) {
        this.refreshLayer('Current Positions')
        this.getCurrentPositionsInterval = setInterval(() => {
          if (
            sessionStorage.token &&
            this.homeScreenComponents &&
            this.isUshrUser
          ) {
            this.refreshLayer('Current Positions')
          } else {
            this.removeCurrentPositionsInterval()
          }
        }, 30000)
      }
    },
    tripsLiveUpdate(bool) {
      // If a trips interval exists, clear it
      if (this.getTripsInterval) {
        this.removeTripsInterval()
      }

      /* If turning on the Trips layer in the
      Dynamic Layer List, set the interval */
      if (bool) {
        this.refreshLayer('Trips')
        this.getTripsInterval = setInterval(() => {
          if (
            sessionStorage.token &&
            this.homeScreenComponents &&
            this.isUshrUser
          ) {
            this.refreshLayer('Trips')
          } else {
            this.removeTripsInterval()
          }
        }, 30000)
      }
    },
    gotErrorFromAttributes(e) {
      let coordinates = new fromLonLat(e.coordinates, 'EPSG:3857')
      let cqlFilter = null
      let layer = null
      let layerParams = null
      // Gets the errors layer
      this.map
        .getLayers()
        .getArray()
        .forEach(obj => {
          let properties = obj.getProperties()
          if (properties.name && (properties.name == 'errors')) {
            layer = obj
            layerParams = layer.getSource().getParams()
            cqlFilter = layerParams.CQL_FILTER
            this.map.getView().setCenter(coordinates)
            this.map.getView().setZoom(19.5)

            this.querySite(
              { coordinate: coordinates },
              layer,
              this.map,
              layerParams.LAYERS,
              `${cqlFilter ? `${cqlFilter} AND` : ''} id ${e.increment ? '>' : '<'} ${e.currentId
              }`
            )
          }
        })
      // REFACTOR SUGGESTION -- WEBGIS-2548 -- code fails if there are no map error layers. layerParams gets set only if there is, and will fail on layerParams.LAYERS if it is still null at this point
    },
    querySite(evt, layers, map, geoserverName, cqlFilter = null) {
      const source = layers.getSource()
      if (!cqlFilter) {
        cqlFilter = source.getParams().CQL_FILTER
      }
      const viewResolution = map.getView().getResolution()
      const options = {
        INFO_FORMAT: 'application/json',
        LAYERS: geoserverName,
        CQL_FILTER: 'INCLUDE' + `${cqlFilter ? ` AND ${cqlFilter}` : ''}`,
        QUERY_LAYERS: geoserverName,
        VIEWPARAMS:
          geoserverName == 'mmp:otonomo_selected_subcountry'
            ? `subcountry:${this.otonomoEditedSubcountry};`
            : null
      }
      let url =
        source.getFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          'EPSG:3857',
          options
        ) + '&FEATURE_COUNT=100&buffer=5&format_options=callback:getJsonFeature&authkey=' + sessionStorage.token

      if (sessionStorage.token) {
        axios
          .get(url, {})
          .then(response => {
            if (this.error && this.errorsLayerVisibility && this.isErrorsLayerOnTop()) {
              this.addError(geoserverName, evt)
              return
            }
            try {
              if (response.data.features.length > 0) {
                this.attribResponse = []
                this.anaAttribResponse = []
                this.features = []
                this.feature_index = 0
                this.queryWindowResponse = []
                this.queryWindowResponse = response
                if (geoserverName == 'mmp:POI_Uploads') {
                  this.populateAnalyticsWindow(response,  geoserverName , evt.coordinate)
                } else {
                  this.populateQueryWindow(response, 'IMAGE', geoserverName)
                }
              }
            } catch (err) {
              this.$router.push({ name: 'Login'})
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    showNextAttribute(value) {
      this.feature_index = value
      this.populateQueryWindow(this.queryWindowResponse, 'IMAGE')
    },
    addError(layer_name, event) {
      let coords = new transform(event.coordinate, 'EPSG:3857', 'EPSG:4326')
      this.errLong = coords[0]
      this.errLat = coords[1]
      this.errLayer = layer_name.split(':')[1]
      this.placeErrPointMarker(event.coordinate)
      this.initDRTNewError()
    },
    placeErrPointMarker(coordinate) {
      this.clearDRTErrorMarker()
      const feature = new Feature({ geometry: new Point(coordinate) })
      feature.setStyle([
        new Style({
          image: new CircleStyle({
            radius: 14,
            fill: new Fill({ color: 'rgba(255, 80, 80, 0.25)' }),
            stroke: new Stroke({ color: 'rgba(255, 80, 80, 0.6)', width: 1 })
          })
        }),
        new Style({
          image: new CircleStyle({
            radius: 7,
            stroke: new Stroke({ color: '#ffffff', width: 2.5 })
          })
        })
      ])
      this.errPointLayer = new VectorLayer({
        source: new VectorSource({ features: [feature] }),
        zIndex: 999
      })
      this.map.addLayer(this.errPointLayer)
    },
    clearDRTErrorMarker() {
      if (this.errPointLayer) {
        this.map.removeLayer(this.errPointLayer)
        this.errPointLayer = null
      }
    },
    async populateAnalyticsWindow(response, geoserverName, coords) {
      let data = response.data
      this.showslider = true
      this.anaAttribResponse = []
      this.anaAttribResponse = this.attribResponse
      this.features = data.features
      this.fullSite = this.features[this.feature_index]
      let site = this.features[this.feature_index].properties
      let clickedLayerName = this.features[this.feature_index]['id']
      this.clickedLayerName = clickedLayerName
      this.attribResponse = []
      for (let key in site) {
        if (site.hasOwnProperty(key)) {
          this.anaAttribResponse.push({
            value: site[key],
            name: key
          })
        }
      }
      this.anaAttribResponse.push({
            value: coords,
            name: 'coords'
          })
      let lat = this.anaAttribResponse.filter((resp) => resp.name == 'lat')[0].value
      let long = this.anaAttribResponse.filter((resp) => resp.name == 'long')[0].value
      let featureCoordinates = [long, lat]

      // Remove previous vectorLayer from the map
      this.map.removeLayer(this.mileageVectorLayer)
      this.map.removeLayer(this.vectorLayer)
      this.showAnalyticsAttributes = true

      // Reset mileage slider to 5mi
      await this.$refs.mileageSliderRef.reset()

      let hexagonCoords = new fromLonLat(featureCoordinates)

      this.addHexagonSymbolizer(hexagonCoords)
      this.addAnalyticsCircle(featureCoordinates)
    },
    calculateMileage(val) {
      this.anaSliderVal = val // change of this value will trigger calculation in MMP_Analytics_Attributes
    }, 
    changeMileageUnit(isKilometers) {
      // isKilometers = boolean value from km / mi toggle
      //    true: unit is km
      //    false: unit is mi
      this.isAnaKilo = isKilometers;
    },
    calculateCircle(featureCoordinates, radius) {
      const circlePoints = [];
      const numPoints = 128; // Number of points in our circle - constant.

      for (let i = 0; i < numPoints; i++) {
        const angle = (i / numPoints) * 360 * (Math.PI / 180);  // Convert degrees to radians

        // Calculate Cartesian offset lat/lon based on the radius
        const dx = radius * Math.cos(angle); // calculate X offset (E/W)
        const dy = radius * Math.sin(angle); // calculate Y offset (N/S)

        // Convert offset (meters) in degrees
        // 111320 = 1° Longitude
        // 110540 = 1° Latitude
        // Longitude degress narrow toward the poles, scale it using cos(latitude) -- in radians (pi / 180)
        const offsetLon = featureCoordinates[0] + (dx / (111320 * Math.cos(featureCoordinates[1] * Math.PI / 180)));
        const offsetLat = featureCoordinates[1] + (dy / 110540);

        const transformedCoords = fromLonLat([offsetLon, offsetLat]); // Transform back to EPSG:3857

        circlePoints.push(transformedCoords);
      }

      // Close the circle
      circlePoints.push(circlePoints[0]);

      return new Polygon([circlePoints])
    },
    async updateRadius(val) {
      const radiusInMeters = this.isAnaKilo ? val * 1000 : val * 1609.34 // 1mi = 1609.34m, 1km = 1000m

      if (this.poiCircle) {
        const geom = this.poiCircle.getGeometry();
        const center = toLonLat(getCenter(geom.getExtent()));

        const circle = await this.calculateCircle(center, radiusInMeters)

        this.poiCircle.setGeometry(circle)
        this.mileageVectorLayer.getSource().changed();
      }
    },
    async addAnalyticsCircle(featureCoordinates) {
      let meters = this.isAnaKilo ? 1000 * 8 : 1609.34 * 5

      // Create the polygon geometry from the circle points
      const circle = await this.calculateCircle(featureCoordinates, meters)
      this.poiCircle = new Feature({
        geometry: circle
      });

      this.poiCircle.setStyle(
        new Style({
          fill: new Fill({ color: '#dde32933' }), // Fill color
          stroke: new Stroke({ color: '#8f9400', width: 2 }),  // Stroke color and width
        })
      )

      this.mileageVectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [this.poiCircle]
        }),
        zIndex: 10
      })

      // Add vector layers to map
      this.map.addLayer(this.mileageVectorLayer)
    },
    async addHexagonSymbolizer(featureCoordinates) {
      // Create point vector layer (hexagon) of clicked feature
      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [
            new Feature({
              type: 'geoMarker',
              geometry: new Point(
                featureCoordinates
              )
            })
          ]
        }),
        zIndex: 1000,
        style: new Style({
          image: new RegularShape({
            points: 6, // Number of points for the hexagon
            radius: 14, // Radius of the hexagon
            fill: new Fill({ color: 'rgba(6, 60, 109, 0.2)' }), // Fill color
            stroke: new Stroke({ color: '#00008B', width: 2 }), // Border color and width
          })
        })
      })

      this.map.addLayer(this.vectorLayer)
    },
    populateQueryWindow(response, layerType, geoserverName = null) {
      let clickedLayerName
      let data = response.data
      let checkAdditionalSegment
      let site
      if (layerType == 'IMAGE') {
        this.features = data.features
        // REFACTOR -- WEBGIS-2548 -- this is not a variable in MMP.vue. Added it.
        this.fullSite = this.features[this.feature_index]
        site = this.features[this.feature_index].properties
      }
      clickedLayerName = this.features[this.feature_index]['id']
      this.clickedLayerName = clickedLayerName
      if (clickedLayerName) {
        clickedLayerName = clickedLayerName.split('.')[0]
        clickedLayerName =
          clickedLayerName.substr(0, 1).toUpperCase() +
          clickedLayerName.substr(1, clickedLayerName.length)
        /* This validation checks whether the clicked layer is random
           segements or a different layer to decide which type of
           attribute window should be opened */
        this.hdLayerSelected = clickedLayerName.includes('_hd')
          ? clickedLayerName
          : null
        if (
          clickedLayerName.includes('Random_segments') ||
          clickedLayerName.includes('_hd') ||
          clickedLayerName.includes('Random_intersections') ||
          clickedLayerName.includes('Biased_')
        ) {
          let resResult = []
          data.features.forEach(element => {
            checkAdditionalSegment = element.properties.evaluate
            if (element.properties.part_number != undefined) {
              if (
                element.properties.part_number ==
                this.recentLayerFetch.partNumber
              ) {
                resResult.push(element)
              }
            } else {
              resResult.push(element)
            }
          })
          if (checkAdditionalSegment == true) {
            if (
              clickedLayerName.includes('Random_segments') ||
              clickedLayerName.includes('_hd')
            ) {
              /**
               * Checking if the modal is already open for certain segment. If it's already open then do not reopen it for the same segment. */        
              if (this.ansiTestingVisible == false || 
                    this.currentModalAnsiSegmentId != ( resResult[1] != null  ?  
                                                      resResult[1].properties.id_ :  
                                                      resResult[0].properties.id_) ) {
                this.ansiTestingVisible = true
                window.setTimeout(() => {
                  if (resResult.length > 1) {
                    this.$refs.AnsiTestingRef.loadAnsiData(resResult[1])
                    this.currentModalAnsiSegmentId = resResult[1].properties.id_
                  } else {
                    this.$refs.AnsiTestingRef.loadAnsiData(resResult[0])
                    this.currentModalAnsiSegmentId = resResult[0].properties.id_
                  }
                  
                }, 1)
                this.onResizeANSITestingWindow()
              }
            } else {
              this.intrsectionTestingVisible = true
              window.setTimeout(() => {
                this.$refs.IntersectionTestingRef.loadAnsiData(resResult[0])
              }, 1)
            }
          }
          if (clickedLayerName.includes('Biased_') && !this.biasedTestingVisible ) {
            this.biasedTestingVisible = true
            window.setTimeout(() => {
              this.$refs.BiasedTestingRef.loadAnsiData(resResult[0])
            }, 1)
            this.onResizeANSITestingWindow()
          }
        } else {
          this.showAttributes = true
        }
      } else {
        this.ansiTestingVisible = false
        this.intrsectionTestingVisible = false
        this.biasedTestingVisible = false
      }
      this.attribResponse = []
      for (let key in site) {
        if (site.hasOwnProperty(key)) {
          this.attribResponse.push({
            value: site[key],
            name: key
          })
        }
      }
      if (geoserverName && geoserverName.includes('mmp:imagery_coverage')) {
        // Stores the GeoServer layer name for usage in getNextCameraImagery method
        this.activeImageryLayer = geoserverName

        // Creates shallow copy of this.features array and sorts it to group features by s3_location
        let featuresCopy = [...this.features].sort(
          (a, b) => a.properties.s3_location - b.properties.s3_location
        )

        // maxImages limits the USV to loading 2 images per clicked location
        let maxImages = Math.min(featuresCopy.length, 2)
        let urls = []
        let urlBase = ''
        let urlPrefix = ''

        for (let i = 0; i < maxImages; i++) {
          let url = featuresCopy[i].properties.s3_location
          switch (clickedLayerName) {
            // REFACTORED -- WEBGIS-2548 -- removed unused switch case option
            //case 'Imagery_coverage':
            default:
              // North America Prefix
              urlPrefix = 'ushr-image'
              urlBase = url.split('ushr-image/')[1]
              urls.push(urlBase)
              break
            case 'Imagery_coverage_jp':
              // Japan Prefix
              urlPrefix = 'japan-image'
              urlBase = url.split('ushr-gen2/')[1]
              urls.push(urlBase)
              break
            case 'Imagery_coverage_me':
              // Middle East Prefix
              urlPrefix = 'ushr-image-me'
              urlBase = url.split('ushr-image-me/')[1]
              urls.push(urlBase)
              break
            case 'Imagery_coverage_eu':
              // Europe Prefix
              urlPrefix = url.split('s3://')[1].split('/')[0] == 'ushr-image-europe' ? 'ushr-image-europe' : 'ushr-europe-image'
              urlBase = url.split('s3://')[1].split('/')[0] == 'ushr-image-europe' ? url.split('ushr-image-europe/')[1] : url.split('ushr-europe/')[1]
              urls.push(urlBase)
              break
          }
        }

        this.ushrImageryAttributeData = {
          asset_id: this.attribResponse[2].value,
          processing_index: this.attribResponse[3].value,
          datetime: this.attribResponse[5].value
        }

        this.streetViewSrc1 = urls[0]
          ? `https://${urlPrefix}.ushrauto-dev.com/${urls[0]}`
          : null
        this.streetViewSrc2 = urls[1]
          ? `https://${urlPrefix}.ushrauto-dev.com/${urls[1]}`
          : null
        this.toggleUSV(true)
      } 
      
      if (geoserverName && geoserverName.includes('mmp:ladybug_imagery_coverage')) {
        // Stores the GeoServer layer name for usage in getNextCameraImagery method
        this.activeImageryLayer = geoserverName

        // Creates shallow copy of this.features array and sorts it to group features by s3_location
        let featuresCopy = [...this.features].sort(
          (a, b) => a.properties.s3_location - b.properties.s3_location
        )

        // maxImages limits the USV to loading 2 images per clicked location
        let maxImages = Math.min(featuresCopy.length, 2)
        let urls = []
        let urlBase = ''
        let urlPrefix = ''

        for (let i = 0; i < maxImages; i++) {
          let url = featuresCopy[i].properties.s3_location
          switch (clickedLayerName) {
            default:
              // North America Prefix
              urlPrefix = 'drt-2d'
              urlBase = url.split('ushr-ladybug-image/')[1]
              urls.push(urlBase)
              break
          }
        }

        this.ladybugImageryAttributeData = {
          asset_id: this.attribResponse[2].value,
          processing_index: this.attribResponse[3].value,
          datetime: this.attribResponse[5].value
        }

        this.ladybugSrc1 = urls[0]
          ? `https://${urlPrefix}.ushrauto-dev.com/${urls[0]}`
          : null

        this.toggleLadybugSV(true)
      }
      // Get array of coordinates. Will be 2D array for linestrings.
      let geomCoordinates = this.fullSite.geometry.coordinates
      // Get length 2 array of coordinates and store them in featureCoordinates
      let featureCoordinates =
        geomCoordinates.length > 2
          ? geomCoordinates[Math.round(geomCoordinates.length / 2)]
          : geomCoordinates
      // Remove previous vectorLayer from the map
      this.map.removeLayer(this.vectorLayer)

      let coords = new fromLonLat(featureCoordinates, 'EPSG:4326')

      // Create vector layer of clicked feature
      this.addHexagonSymbolizer(coords)
    },
    closeAttTable() {
      this.showAttributes = false
      this.attribResponse = null
      // Removes circle that appears on map when user inputs coordinates to zoom to
      this.map.removeLayer(this.vectorLayer)
      this.vectorLayer = null
    },
    resetBaseLayer() {
      this.map.getLayers().forEach(layer => {
        if (layer != undefined && layer.get('name') != undefined) {
          if (layer.get('name').includes('base')) {
            if (this.checkLayer(layer)) {
              this.map.removeLayer(layer)
            }
          }
        }
      })
    },
    toggleBaseLayer(newBaseLayer) {
      this.resetBaseLayer()
      this.currentBaseMap = newBaseLayer // REFACTOR SUGGESTION -- WEBGIS-2548 -- I feel like this could break something if newBaseLayer doesn't match any of the below options
      switch (newBaseLayer) {
        case 'OpenStreetMap':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new OSM({ crossOrigin: 'anonymous' }),
              name: 'OSM base layer',
              zIndex: 2
            })
          )
          break
        case 'Google':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new XYZ({
                attributions: [`<p style="width: 25rem; text-align: left; margin: 0px;">
                                DMP's use of the Google Maps Platform is provided in accordance with the principles of fair use. DMP does not create any content derived from this data. DMP does not augment any mapping-related dataset that is a substitution for Google Maps. This data is not being used in connection with real-time navigation or autonomous vehicle control.</p>`,
                  `<a href="https://www.google.com/intl/en-GB_US/help/terms_maps.html">Google Map</a>`
                ],
                //url: 'http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga'
                url: 'http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga&key=AIzaSyB_S_ytq7NeTEQmW8E3of_UmefkciIb0nw&location=34.660908,-120.459155&heading=330&pitch=-10&fov=35'
              }),
              name: 'Google base layer',
              zIndex: 2
            })
          )
          break
        case 'Azure':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new XYZ({
                url: `https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&subscription-key=${process.env.AZURE_MAPS_KEY}`,
                attributions: '© Microsoft Azure Maps',
                crossOrigin: 'anonymous',
                // Azure 'microsoft.imagery' tiles only exist up to zoom 19.
                // Cap the tile grid so OpenLayers over-zooms (upscales) the z19
                // tiles past 19 instead of requesting missing tiles (black map).
                maxZoom: 19
              }),
              name: 'Azure base layer',
              zIndex: 2
            })
          );
          break;
        case 'Black':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new OSM({ crossOrigin: 'anonymous' }),
              name: 'Black base layer',
              zIndex: 2,
              opacity: 0
            })
          )
          break
      }
    },
    initHardDriveTracking() {
      this.$bvModal.show('hardDriveTrackingModal')
    },
    getAdmin(userEmail) {
      this.isAdmin = this.globalVerifyCurrentUserRole('USHR Platform Admin') || this.globalVerifyCurrentUserRole('USHR Acquisition Admin')
    },
    checkRoles() {
      let userRole = this.user.role
      if (
        userRole == 'USHR Platform Admin' ||
        userRole == 'USHR Acquisition Admin'
      ) {
        this.isAdmin = true
      }
      if (
        userRole == 'GM User' ||
        userRole == 'Nissan User' ||
        userRole == 'Rivian User'
      ) {
        this.ushrLayersVisible = false
        this.hdtVisible = false
      }
      if (
        userRole == 'Nissan User' ||
        userRole == 'Rivian User' ||
        userRole == 'Generic User' ||
        userRole == 'Subaru User'
      ) {
        this.showError = false
      }
      if (this.isUshrUser) {
        // If USHR permission...
        this.getLayers(this.ushrLayers_releaseId)
      }
    },
    // This function fetches the legends for each layer for DRT on button click
    getLegend(layerName) {
      this.map.getLayers().forEach(layer => {
        if (layer.get('name') == layerName) {
          // layerUrl will be 'undefined' if getLegendUrl fails to generate a URL.
          let layerUrl = layer
            .getSource()
            .getLegendUrl(this.map.getView().getResolution())
          if (layerUrl) {
            this.legendImgSrc = `${layerUrl}&LEGEND_OPTIONS=fontAntiAliasing:true;fontSize:17;bgColor:0xffffff;fontColor:0x003a3a3a;forceLabels:on;` + '&authkey=' + sessionStorage.token
            this.layerLegendName = layerName
            // After setting legend URL, show legend component
            this.layerLegend = true
          } else {
            console.log('FAILED TO FIND URL FOR LEGEND.')
          }
        }
      })
    },
    // This function fetches the legends for the DRT error layer
    getErrorLayerLegend() {
      this.map.getLayers().forEach(layer => {
        if (layer.get('name') == 'errors') {
          // layerUrl will be 'undefined' if getLegendUrl fails to generate a URL.
          let layerUrl = layer
            .getSource()
            .getLegendUrl(this.map.getView().getResolution())
          if (layerUrl) {
            let imgSrc =
              layerUrl +
              '&LEGEND_OPTIONS=fontAntiAliasing:true;fontSize:17;bgColor:0xffffff;fontColor:0x003a3a3a;forceLabels:on;' + '&authkey=' + sessionStorage.token
            this.errorsLayerLegend = imgSrc
          } else {
            console.log('FAILED TO FIND URL FOR LEGEND.')
          }
        }
      })
    },
    // This function generates the button list to be disabled even on zoom in and zoom out
    zoomControlLayers(layers) {
      let zoomAr = []
      for (let key in layers) {
        if (layers[key].zoomControl) {
          zoomAr.push({
            layer: layers[key].layer,
            ButtonName: key,
            minZoom:
              layers[key].minZoom == undefined ? null : layers[key].minZoom
          })
        }
      }
      return zoomAr
    },
    // This function checks for the zoom level control for DRT and can be reused
    setListeners() {
      this.olMapMoveStartKey = this.map.on('movestart', evt => {
        this.lidarIsLoading = true
        this.zoomStarted = this.map.getView().getZoom()
      })
      this.olMapMoveEndKey = this.map.on('moveend', evt => {
        this.zoomControlArr = this.zoomControlLayers(this.mmp_layersObj)
        this.zoomEnded = this.map.getView().getZoom()

        // Zoom controlled layer handling
        for (let i in this.zoomControlArr) {
          let zoomLayer = this.zoomControlArr[i]
          let layerIndex = this.shortTermLayerMemory.indexOf(
            zoomLayer.ButtonName
          )
          let layerRemembered = layerIndex != -1
          let item = document.getElementById(zoomLayer.ButtonName)
          let showLayer =
            zoomLayer.minZoom == null
              ? this.zoomEnded >= this.zoomLevelCap
              : this.zoomEnded >= zoomLayer.minZoom
          if (item) {
            // If user is zoomed in enough...
            if (showLayer) {
              /* If the layer exists in short term memory,
              remove it since the layer is being enabled. */
              if (layerRemembered) {
                this.toggleLayerVisibility(zoomLayer.ButtonName)
                this.shortTermLayerMemory.splice(layerIndex, 1)
              }
            } else {
              this.map.getLayers().forEach(layer => {
                if (layer.get('name') == zoomLayer.ButtonName) {
                  /* If turning the layer off, add it to short term layer
                  memory to be enabled again later. */
                  if (!layerRemembered) {
                    this.shortTermLayerMemory.push(zoomLayer.ButtonName)
                  }
                }
              })
              this.unloadLayers(zoomLayer.ButtonName)
            }
          }
        }
        // Lidar zoom warning handling
        if (this.showLidarPanel) {
          this.lidarDownload(this)
        }
        this.setLidarMinZoomAchieved(this.zoomEnded >= 17)
      })
    },
    updateErrorOnClick() {
      // Set listener for updating error
      this.updateErrorOnSingleClickEventListener = this.map.on(
        'singleclick',
        evt => {
          if (!this.isErrorsLayerOnTop()) return
          let source = this.errorsLayer.getSource()
          let viewResolution = this.map.getView().getResolution()
          let url =
            source.getFeatureInfoUrl(
              evt.coordinate,
              viewResolution,
              'EPSG:3857',
              {
                INFO_FORMAT: 'application/json',
                LAYERS: 'gm:gm_errors', 
                QUERY_LAYERS: 'gm:gm_errors'
              }
            ) +
            '&FEATURE_COUNT=100&buffer=5&format_options=callback:getJsonFeature&authkey=' + sessionStorage.token

          if (sessionStorage.token) {
            axios
              .get(url, {})
              .then(response => {
                if (response.data && response.data.features && response.data.features[0] != null) {
                  let resProps = response.data.features[0].properties

                  /* Both processed variables are checking to make sure they are
                  not null and are of type string. If they are, they need to have
                  1 added to them because the errors database table is 0-indexed
                  while the error_severity and error_status database tables are
                  both 1-indexed (id columns). If these are null, then just return
                  null as their dropdown menus will handle it by selecting the
                  disabled empty option. */
                  let processedSeverity =
                    resProps.severity_id != null &&
                      typeof resProps.severity_id == 'string'
                      ? parseInt(resProps.severity_id) + 1
                      : resProps.severity_id
                  let processedStatus =
                    resProps.status_id != null &&
                      typeof resProps.status_id == 'string'
                      ? parseInt(resProps.status_id) + 1
                      : resProps.status_id

                  this.updateErrorDataSource = {
                    comments: resProps.comments,
                    created_date: resProps.created_date,
                    created_user: resProps.created_user,
                    dataset: resProps.dataset,
                    id: resProps.id,
                    layer_name: resProps.layer_name,
                    notes: resProps.notes,
                    project_id: resProps.project_id,
                    severity: processedSeverity,
                    status: processedStatus,
                    updated_date: resProps.updated_date,
                    updated_user: resProps.updated_user,
                    region: resProps.region,
                    lat_lon: resProps.lat_lon,
                    province: resProps.province,
                    error_type: resProps.error_type,
                    layer_attribute: resProps.layer_attribute,
                    issue_id: resProps.issue_id,
                    country: resProps.country,
                    archived_date: resProps.archived_date
                  }
                  this.initDRTEditError()
                }
              })
              .catch(function (error) {
                console.log(error)
              })
          } else {
            console.log('No User Token')
          }
        }
      )
    },
    remoteUpdateErrorOnClick() {
      new unByKey(this.updateErrorOnSingleClickEventListener)
    },
    onResize() {
      let difference
      let tool

      if (this.drtComponents) {
        tool = 'Delivery Review Tool'
      } else if (this.ansiComponent) {
        tool = 'ANSI'
      }

      // REFACTOR SUGGESTION -- WEBGIS-2548 -- What is the point of having a switch here if there's just a default - just run the one line
      switch (tool) {
        default:
          // Subnav window height
          difference = 140
          break
      }

      this.windowHeight = window.innerHeight
      this.windowWidth = window.innerWidth
      this.layersListMaxHeight = `max-height: ${this.windowHeight - difference}px;`
    },
    onResizeLidar() {
      let lidarPanelMaxHeight = window.innerHeight - 500
      this.lidarMaxHeight = `max-height: ${lidarPanelMaxHeight}px;min-height: 40px;`
      if (
        this.$refs.mainLayout != undefined &&
        !this.homeScreenComponents &&
        this.showLidarPanel &&
        this.distinct_lidar.length > 0
      ) {
        let lidarLayoutObj = this.layout.filter(e => e.i == 12)[0]
        let lidarTilesElement = document.getElementById('lidarTiles')
        let lidarTilesHeight = Math.min(
          lidarPanelMaxHeight,
          lidarTilesElement.offsetHeight
        )
        let lidarTilesWidth = lidarTilesElement.offsetWidth

        // Sets Vue Grid Layout Lidar Layer Panel Object's height and width to dynamic value on window resize
        lidarLayoutObj.h = lidarTilesHeight / this.$refs.mainLayout.rowHeight
        lidarLayoutObj.w =
          (lidarTilesWidth / window.innerWidth) * this.$refs.mainLayout.colNum
      }
    },
    onResizeMainMenuOrDLL() {
      // This method resizes the Main Menu and Dynamic Layer List components
      if (this.$refs.mainLayout != undefined) {
        let layerLegendLayoutObj = this.layout.filter(e => e.i == 2)[0]
        let mainPanelLayoutObj = this.layout.filter(e => e.i == 10)[0]
        let userProfileElement = document.getElementById('userProfile')
        let tabNavElement = document.getElementById('tabnav')
        let mainMenuElement = document.getElementById('mainMenu')

        if (
          this.homeScreenComponents &&
          userProfileElement &&
          tabNavElement &&
          mainMenuElement
        ) {
          // Resize the Main Menu
          let mainMenuElementHeight =
            userProfileElement.offsetHeight + tabNavElement.offsetHeight + 10
          let mainMenuElementWidth = mainMenuElement.offsetWidth

          // Dynamic styling based on window height
          this.mainMenuMaxHeight = `max-height: ${mainMenuElementHeight}px;min-height: 200px;width: 410px;`

          // Sets Vue Grid Layout Main Panel Object's height and width to dynamic values on window resize
          mainPanelLayoutObj.h =
            mainMenuElementHeight / this.$refs.mainLayout.rowHeight
          mainPanelLayoutObj.w =
            (mainMenuElementWidth / window.innerWidth) *
            this.$refs.mainLayout.colNum
        } else {
          // Resizes Feature Buttons grid-item
          let featureButtonsLayoutObj = this.layout.filter(e => e.i == 7)[0]
          let featureButtonsElement = document.getElementById('featureButtons')

          if (featureButtonsElement) {
            let featureButtonsHeight = featureButtonsElement.offsetHeight
            let featureButtonsWidth = featureButtonsElement.offsetWidth
            featureButtonsLayoutObj.h =
              featureButtonsHeight / this.$refs.mainLayout.rowHeight
            featureButtonsLayoutObj.w =
              (featureButtonsWidth / window.innerWidth) *
              this.$refs.mainLayout.colNum
          }

          let layerList = null
          let layerListHeight = 0
          let layerListWidth = 0
          let layerLegendHeight = 0
          let layerLegendWidth = 0

          if (this.ansiComponent) {
            layerList = document.getElementById('ANSIDynamicLayerList')
          } else if (this.drtComponents) {
            layerList = document.getElementById('DRTDynamicLayerList')
          } else if (this.highwayDBcloudComponents) {
            layerList = document.getElementById('HighwayDBCloudLayerList')
          } else if (this.analyticsVisible) {
            layerList = document.getElementById('AnalyticsDLL')
          } else if (this.wclVisible) {
            layerList = document.getElementById('wclDLL')
          }

          if (layerList != null) {
            // Resize the Dynamic Layer List in ANSI and DRT components
            layerListHeight = layerList.offsetHeight
            layerListWidth = layerList.offsetWidth

            // Sets Vue Grid Layout Main Panel Object's height and width to dynamic values on window resize
            mainPanelLayoutObj.h =
              layerListHeight / this.$refs.mainLayout.rowHeight
            mainPanelLayoutObj.w =
              (layerListWidth / window.innerWidth) *
              this.$refs.mainLayout.colNum
          }

          // Resizes the layer legend
          let layerLegendElement = document.getElementById('layerLegend')
          let minimumLayerLegendHeight = 30 // 30px spacing to grant room for legend header
          let actualLayerLegendHeight = this.layerLegendMinimized
            ? minimumLayerLegendHeight
            : this.layerLegendDimensions.height + minimumLayerLegendHeight
          if (layerLegendElement) {
            layerLegendHeight = Math.min(
              actualLayerLegendHeight,
              layerListHeight
            )
            layerLegendWidth = this.layerLegendDimensions.width
            layerLegendLayoutObj.h =
              layerLegendHeight / this.$refs.mainLayout.rowHeight
            layerLegendLayoutObj.w =
              (layerLegendWidth / window.innerWidth) *
              this.$refs.mainLayout.colNum
            layerLegendLayoutObj.x =
              mainPanelLayoutObj.x + mainPanelLayoutObj.w
            // Top-right corner of the layer list.
            layerLegendLayoutObj.y = 0
          }

          this.layerLegendMaxHeight = `max-height: ${layerListHeight}px;`
        }
      }
    },
    onResizeANSITestingWindow() {
      if (this.$refs.mainLayout != undefined) {
        let ANSITestingWindowLayoutObj = this.layout.filter(e => e.i == 5)[0]
        let ANSITestingWindowElement =
          document.getElementById('AnsiTestingWindow')
        if (ANSITestingWindowElement) {
          ANSITestingWindowLayoutObj.h =
            ANSITestingWindowElement.offsetHeight /
            this.$refs.mainLayout.rowHeight
          // NOTE: intentionally do NOT recompute `w` here.
          // The window's position is set via `.ansiTestingComponent { margin-left: 70% }`,
          // and CSS margin percentages resolve against the grid cell's width.
          // Overwriting `w` after the window has already painted changes that width,
          // which shifts the 70% margin and makes the window visibly jump on open.
          // Keeping the width stable lets it paint once and stay in place.
        }
      }
    },
    toggleError() {
      this.error = !this.error
      // Mode just armed: bring errors layer up and start listening for the
      // map click that places the new error. Mode turned off: stop listening.
      if (this.error) {
        this.moveErrorsLayerToTop()
        this.addErrorOnClick()
      } else {
        this.removeAddErrorOnClick()
      }
    },
    addErrorOnClick() {
      // Dedicated placement listener for Add mode (mirrors updateErrorOnClick).
      // Without this, adding an error relied on the generic attributes-window
      // click listener, which isn't active in plain DRT error mode — so the
      // Add Error modal never opened.
      this.addErrorOnSingleClickEventListener = this.map.on('singleclick', evt => {
        if (!this.isErrorsLayerOnTop()) return
        let coords = new transform(evt.coordinate, 'EPSG:3857', 'EPSG:4326')
        this.errLong = coords[0]
        this.errLat = coords[1]
        this.placeErrPointMarker(evt.coordinate)
        this.initDRTNewError()
      })
    },
    removeAddErrorOnClick() {
      new unByKey(this.addErrorOnSingleClickEventListener)
    },
    toggleUpdateError() {
      this.updateError = !this.updateError
      // If update error was just toggled on
      if (this.updateError) {
        this.updateErrorOnClick()
        this.moveErrorsLayerToTop()
        // Else update error was just toggled off
      } else {
        this.remoteUpdateErrorOnClick()
      }
    },
    moveErrorsLayerToTop() {
      this.putLayerOnTop({
        payload: { layerName: 'errors', tool: 'DRT' },
        resolve: () => {}
      })
    },
    isErrorsLayerOnTop() {
      const topLayer = this.drtLayersButtonsCtrl[0]
      return !!topLayer && (topLayer.name === 'errors' || topLayer.display_name === 'errors')
    },
    maxOrMinLegend(bool) {
      this.layerLegendMinimized = bool
      this.onResizeMainMenuOrDLL()
    },
    closeLegend() {
      this.layerLegend = false
      this.layerLegendDimensions = {
        height: 0,
        width: 0
      }
      this.onResizeMainMenuOrDLL()
    },
    maxOrMinLidar(bool) {
      this.lidarPanelMinimized = bool
    },
    maxOrMinAttributes(bool) {
      this.attributesPanelMinimized = bool
    },
    // This function clears the Selset selection and refreshes the ANSI layer loaded on map
    clearAnsiSelection() {
      this.$refs?.ansiLayers.$refs?.ANSI_Tools?.clearAnsiSelection()
      this.ansiTestingVisible = false
      this.intrsectionTestingVisible = false
    },
    updateDRTLayersPartNumber(id) {
      this.getLayers(id)
      this.drt_releaseId = id
      this.errorsLayerVisibility = false
      this.spinnerManager = []
      this.onResize()
    },
    moveStreetView(elementId) {
      // This method resizes the Main Menu and Dynamic Layer List components
      if (this.$refs.mainLayout != undefined) {
        let layoutId =
          elementId == 'ushrStreetViewPanel'
            ? 16
            : elementId == 'googleStreetViewPanel'
              ? 4
              : 0
        if (layoutId != 0) {
          // Resize the GSV/USV
          let layoutObj = this.layout.filter(e => e.i == layoutId)[0]
          let streetViewElement = document.getElementById(elementId)
          let streetViewHeight = streetViewElement.offsetHeight
          let streetViewWidth = streetViewElement.offsetWidth

          // Sets Vue Grid Layout GSV/USV Object's height and width to dynamic values on window resize
          layoutObj.h = streetViewHeight / this.$refs.mainLayout.rowHeight
          layoutObj.w =
            (streetViewWidth / window.innerWidth) * this.$refs.mainLayout.colNum
        }
      }
    },
    toggleGSV(value) {
      this.showStreetView = value
      if (!this.showStreetView) {
        /* Resets the GSV's positioning on close,
        helpful if user dragged GSV off-screen */
        let gsvElement = document.getElementById(
          'googleStreetViewPanel'
        ).parentElement
        gsvElement.removeAttribute('style')
      }
    },
    toggleUSV(value) {
      this.showUshrStreetView = value
      if (!value) {
        this.streetViewSrc1 = null
        this.streetViewSrc2 = null
      }
    },
    toggleLadybugSV(value) {
      this.showLadybugStreetView = value
      if (!value) {
        this.ladybugSrc1 = null
      }
    },
    getGSV(coord) {
      this.iFrameSrc = `https://www.google.com/maps/embed/v1/streetview?key=AIzaSyB_S_ytq7NeTEQmW8E3of_UmefkciIb0nw&location=${coord[1]},${coord[0]}&pitch=-10&fov=35`
    },
    // REFACTOR -- WEBGIS-2548 -- this fn is never used - also had to add baseMapsToggle as a variable above.
    collapseBaseMaps() {
      this.baseMapsToggle = !this.baseMapsToggle
    },
    exportFile(type) {
      this.map.getLayers().forEach(layer => {
        // Check if requested layer matches
        if (layer.get('name') == 'errors') {
          let layerInfo = layer.getSource()
          let url = layerInfo.urls[0].split('wms')[0]
          let layerType = layerInfo.params_.LAYERS
          let extent = this.map.getView().calculateExtent(this.map.getSize())
          let filterExtent = new transformExtent(
            extent,
            new projGet('EPSG:3857'),
            new projGet('EPSG:4326')
          )
          extent = extent.join(',')
          filterExtent = filterExtent.join(',')
          let outputFormat = type == 'csv' ? 'CSV' : 'SHAPE-ZIP'
          url += `ows?service=WFS&version=1.0.0&request=GetFeature&authkey=${sessionStorage.token}&typeName=${layerType}&bbox=${extent},EPSG:3857&outputFormat=${outputFormat}`
          if(outputFormat=='CSV'){
          url += '&propertyName=id,lat_lon,created_user,created_date,updated_date,updated_user,project_id,layer_name,status,status_id,severity,severity_id,comments,notes,archived_date,archived,dataset,region_id,region,province,country,issue_id,layer_attribute,error_type'
          }
          window.open(url)
        }
      })
    },
    async putLayerOnTop(data) {
      switch (data.payload.tool) {
        case 'DRT':
          this.drtLayersButtonsCtrl = this.putLayerOnTopHelper(
            this.drtLayersButtonsCtrl,
            data.payload.layerName
          )
          break
        case 'ANSI':
          this.ansiLayersButtonCtrl = await this.putLayerOnTopHelper(
            this.ansiLayersButtonCtrl,
            data.payload.layerName
          )
          break
        case 'USHR':
          this.ushrLayersButtonsCtrl = this.putLayerOnTopHelper(
            this.ushrLayersButtonsCtrl,
            data.payload.layerName
          )
          break
        case 'CUSTOMER':
          this.customerLayersButtonsCtrl = this.putLayerOnTopHelper(
            this.customerLayersButtonsCtrl,
            data.payload.layerName
          )
          break
        case 'WCL':
          this.wclLayersButtonsCtrl = this.putLayerOnTopHelper(
            this.wclLayersButtonsCtrl,
            data.payload.layerName
          )
      }

      data.resolve();
    },
    putLayerOnTopHelper(arr, layerName) {
      for (let layerIndex in arr) {
        let layer = arr[layerIndex]
        if (layer.display_name == layerName || layer.name == layerName) {
          // Removes layer from array
          arr.splice(layerIndex, 1)
          // Adds layer back at the beginning of the array
          arr.unshift(layer)
          break
        }
      }
      return arr
    },
    initTool(data) {
      this.customerProjectId = data.customer.id
      this.customerName = data.customer.name
      this.apiUrl = data.customer.api_url
      this.loadProject(data.project, true)
      this.$bvModal.show('datasetSelection')
    },
    updateANSILayersPartNumber(e) {
      this.currentANSIPartNumber = e
      this.currentAnsiSegment = null
    },
    updateANSIToolsSelset(selset) {
      this.currentANSISelset = selset.selset
      this.layerDefinition = selset.type
      this.ansiLayersButtonCtrl = []
      this.ansiSelectedSelset = selset.selset
      this.ansiLayersButtonCtrl = this.ansilayerList.filter(
        e =>
          e.layer_definition == this.layerDefinition ||
          e.layer_definition == undefined
      )
    },
    showZoomLevel() {
      this.map.on('moveend', evt => {
        this.zoomLevel = this.map.getView().getZoom()
      })
    },
    zoomLevelSaved(value) {
      this.showZoomPanel = value
    },
    // Toggles the ANSI night mode. Applies a body-level class that a dedicated
    // stylesheet uses to darken the on-map ANSI panels (layer list, navigation,
    // speed limit). Kept as a body class so scoped panel styles are overridden
    // globally without wiring a prop through every ANSI component.
    toggleNightMode() {
      this.nightMode = !this.nightMode
      document.body.classList.toggle('ansi-night-mode', this.nightMode)
    },
    setUserId(user) {
      this.userId = user
      this.$bvModal.show('UpdateUserModal')
    },
    getReleases(data) {
      // Sorts releases in descending date order
      let descData = data.toSorted(
        (a, b) => new Date(b.release_date) - new Date(a.release_date)
      )
      this.releases = descData
    },
    getShowAttributes(data) {
      this.showAttributes = data
      if (!this.showAttributes) {
        // Removes circle that appears on map when user inputs coordinates to zoom to
        this.map.removeLayer(this.vectorLayer)
        this.vectorLayer = null
      }
    },
    getErrorsLayer(data) {
      this.errorsLayer = data
    },
    getVectorlayer(layer) {
      this.map.addLayer(layer)
    },
    showCoordCard(bool) {
      this.showCoordinateCard = bool
    },
    showCoords(coords) {
      this.googleCoords = coords.google
      this.qgisCoords = coords.qgis
      this.showCoordinateCard = true
    },
    setLidarMinZoomAchieved(bool) {
      this.lidarMinZoomAchieved = bool
    },
    inactivityDetection(inactivity) {
      const currentTime = Date.now()
      const elapsedSeconds = Math.floor((currentTime - this.inactivityStartTime) / 1000)

      // Subtracts one second from each timer
      this.timeBeforeLogout = this.timeBeforeLogoutDefault - elapsedSeconds;
      this.timeBeforeInactivityWarning = this.timeBeforeInactivityWarningDefault - elapsedSeconds;

      if (!this.$store.state.idleVue.isIdle) {
        /* If user isn't idle, set timers to maximum
        value and hide the inactivity warning modal. */
        this.timeBeforeLogout = this.timeBeforeLogoutDefault
        this.timeBeforeInactivityWarning = this.timeBeforeInactivityWarningDefault
        this.inactivityWarningShowing = false
        this.blurConfig.isBlurred = false
        this.$bvModal.hide('inactivityModal');
        this.inactivityStartTime = Date.now();
      } else if (
        this.timeBeforeInactivityWarning < 1 &&
        !this.inactivityWarningShowing
      ) {
        /* Else if inactivity modal timer hits 0 and
        the inactivity modal isn't already displayed,
        show the inactivity modal and blur everything
        behind it. */
        this.inactivityWarningShowing = true
        this.blurConfig.isBlurred = true
        this.$bvModal.show('inactivityModal')
      }
      if (this.timeBeforeLogout < 1) {
        /* If the logout timer hits 0, stop detecting
        inactivity and log the user out. */
        clearInterval(inactivity)
        this.$router.push({ name: 'Login' })
      }
    },
    async extentChanged(extentObj) {
      let previousExtent = this.selectedExtent
      this.selectedExtent = extentObj.selectedExtent
      this.closeAnaAttTable()
      this.map.setView(extentObj.view)
      if (
        !this.homeScreenComponents &&
        previousExtent != this.selectedExtent &&
        !extentObj.changedViaDatasetSelection
      ) {
        await this.getLayers(
          this.recentLayerFetch.release_id,
          this.recentLayerFetch.store_name,
          this.recentLayerFetch.workspace,
          this.recentLayerFetch.delivery_coverage_store,
          this.recentLayerFetch.partNumber
        )
      } else if ((this.user.org == 5) && this.homeScreenComponents) {
        this.getGenericCoverageLayer()
      } else if (this.isAdmin && this.homeScreenComponents) {
        // If USHR permission...
        this.getLayers(this.ushrLayers_releaseId)
      }
    },
    resetGroupAddedFeedback() {
      this.newGroupAdded = {
        groupAdded: false,
        feedbackHidden: true
      }
    },
    groupAddedChange(e) {
      this.newGroupAdded = {
        groupAdded: e,
        feedbackHidden: false
      }
    },
    showCustomerLayer(value) {
      this.showCustLayer = value
    },
    getGenericCoverageLayer() {
      if (sessionStorage.token) {
        this.customerLayersButtonsCtrl.forEach(layer => {
          let layerToToggle = this.cust_layersObj[layer.name].layer
          this.map.removeLayer(layerToToggle)
        })
        this.customerLayersButtonsCtrl = []
        axios
          .get(
            process.env.API_LOCATION + '/api/layer/getGenericCoverageLayers',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                customer_id: this.user.org,
                extent: this.selectedExtent
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getGenericCoverageLayers API Call Error: ' + content.errors)
            } else {
              let layerLinks = []
              content.rows
                .filter(e => e.visibility != false)
                .forEach(link => {
                  let linkObj = link.link_object
                  // Replaces all underscores with spaces
                  let output = linkObj.name.replace(/_/g, ' ')
                  linkObj['display_name'] = output
                  layerLinks.push(linkObj)
                  this.customerLayersButtonsCtrl.push({
                    name: linkObj.name,
                    legendURL: linkObj.info.legend_url
                  })
                })
              this.cust_layersObj = createLayers(layerLinks, this.map)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    getCustomerCoverageLayers() {
      if (sessionStorage.token) {
        this.customerLayersButtonsCtrl = []
        axios
          .get(
            process.env.API_LOCATION + '/api/layer/getCustomerCoverageLayers',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                customer_id: this.user.org
              }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getCustomerCoverageLayers API Call Error: ' + content.errors)
            } else {
              let layerLinks = []
              content.rows
                .filter(e => e.visibility != false)
                .forEach(link => {
                  let linkObj = link.link_object
                  // Replaces all underscores with spaces
                  let output = linkObj.name.replace(/_/g, ' ')
                  linkObj['display_name'] = output
                  layerLinks.push(linkObj)
                  this.customerLayersButtonsCtrl.push({
                    name: linkObj.name,
                    legendURL: linkObj.info.legend_url
                  })
                })
              this.cust_layersObj = createLayers(layerLinks, this.map)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    initGTPModal() {
      this.$bvModal.show('gtpModal')
    },
    initImageCarousel() {
      this.$bvModal.show('imageCarousel')
    },
    initEODFieldReviewCarousel() {
      this.loadProject('EodFieldReview')
    },
    getNextCameraImagery(processingIndexModifier) {
      let currentProcessingIndex =
        this.ushrImageryAttributeData.processing_index
      let newProcessingIndex = currentProcessingIndex + processingIndexModifier
      let toastMsg = 'End of selected trail.'
      let toastObj = {
        title: 'Street View Error',
        toaster: 'b-toaster-top-right'
      }

      if (
        this.ushrImageryData.assetId != this.ushrImageryAttributeData.asset_id
      ) {
        /* If the assetId has changed from a user clicking on a new
        Ushr Imagery point on the map, refresh ushrImageryData. */
        this.ushrImageryData = {
          assetId: this.ushrImageryAttributeData.asset_id,
          currentProcessingIndex:
            this.ushrImageryAttributeData.processing_index,
          processingIndexLocationArray: []
        }

        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION +
              '/api/drt/getCameraImageryProcessingIndices',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  asset_id: this.ushrImageryData.assetId,
                  extent: this.selectedExtent
                }
              }
            )
            .then(response => {
              const content = response.data.rows
              let newProcessingIndexLocationArray = []
              content.forEach(record => {
                let obj = {
                  lat: record.lat,
                  long: record.long,
                  processing_index: record.processing_index
                }
                newProcessingIndexLocationArray.push(obj)
              })
              this.ushrImageryData.processingIndexLocationArray =
                newProcessingIndexLocationArray

              if (newProcessingIndex >= 0) {
                if (
                  this.ushrImageryData.processingIndexLocationArray.length > 0
                ) {
                  // Image(s) found in DB
                  let arr = this.ushrImageryData.processingIndexLocationArray
                  let index =
                    arr.findIndex(
                      obj => obj.processing_index === currentProcessingIndex
                    ) + processingIndexModifier
                  let coords = [arr[index].long, arr[index].lat]
                  let imageryLayer
                  Object.entries(this.mmp_layersObj).forEach(layerArray => {
                    let layer = layerArray[1].layer
                    let layerGeoserverName = layer
                      .getSource()
                      .getParams().LAYERS
                    if (layerGeoserverName == this.activeImageryLayer) {
                      imageryLayer = layer
                    }
                  })
                  this.querySite(
                    {
                      coordinate: new transform(
                        coords,
                        'EPSG:4326',
                        'EPSG:3857'
                      )
                    },
                    imageryLayer,
                    this.map,
                    this.activeImageryLayer
                  )
                } else {
                  // No image(s) found in DB due to positive end of trail
                  this.$bvToast.toast(toastMsg, toastObj)
                }
              } else {
                this.$bvToast.toast(toastMsg, toastObj)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          this.$router.push({ name: 'Login' })
        }
      } else if (newProcessingIndex >= 0) {
        if (this.ushrImageryData.processingIndexLocationArray.length > 0) {
          // Image(s) found in DB
          let arr = this.ushrImageryData.processingIndexLocationArray
          let index =
            arr.findIndex(
              obj => obj.processing_index === currentProcessingIndex
            ) + processingIndexModifier
          let coords = [arr[index].long, arr[index].lat]
          let imageryLayer
          Object.entries(this.mmp_layersObj).forEach(layerArray => {
            let layer = layerArray[1].layer
            let layerGeoserverName = layer.getSource().getParams().LAYERS
            if (layerGeoserverName == this.activeImageryLayer) {
              imageryLayer = layer
            }
          })
          this.querySite(
            { coordinate: new transform(coords, 'EPSG:4326', 'EPSG:3857') },
            imageryLayer,
            this.map,
            this.activeImageryLayer
          )
          this.getGSV(coords)
        } else {
          // No image(s) found in DB due to positive end of trail
          this.$bvToast.toast(toastMsg, toastObj)
        }
      } else {
        this.$bvToast.toast(toastMsg, toastObj)
      }
    },
    getNextLadybugCameraImagery(processingIndexModifier) {
      let currentProcessingIndex =
        this.ladybugImageryAttributeData.processing_index
      let newProcessingIndex = currentProcessingIndex + processingIndexModifier
      let toastMsg = 'End of selected trail.'
      let toastObj = {
        title: 'Street View Error',
        toaster: 'b-toaster-top-right'
      }

      if (
        this.ladybugImageryData.assetId != this.ladybugImageryAttributeData.asset_id
      ) {
        /* If the assetId has changed from a user clicking on a new
        Ushr Imagery point on the map, refresh ladybugImageryData. */
        this.ladybugImageryData = {
          assetId: this.ladybugImageryAttributeData.asset_id,
          currentProcessingIndex:
            this.ladybugImageryAttributeData.processing_index,
          processingIndexLocationArray: []
        }

        if (sessionStorage.token) {
          axios
            .get(
              process.env.API_LOCATION +
              '/api/drt/getLadybugCameraImageryProcessingIndices',
              {
                headers: {
                  'x-auth-token': sessionStorage.token
                },
                params: {
                  asset_id: this.ladybugImageryData.assetId,
                  extent: this.selectedExtent
                }
              }
            )
            .then(response => {
              const content = response.data.rows
              let newProcessingIndexLocationArray = []
              content.forEach(record => {
                let obj = {
                  lat: record.lat,
                  long: record.long,
                  processing_index: record.processing_index
                }
                newProcessingIndexLocationArray.push(obj)
              })
              this.ladybugImageryData.processingIndexLocationArray =
                newProcessingIndexLocationArray

              if (newProcessingIndex >= 0) {
                if (
                  this.ladybugImageryData.processingIndexLocationArray.length > 0
                ) {
                  // Image(s) found in DB
                  let arr = this.ladybugImageryData.processingIndexLocationArray
                  let index =
                    arr.findIndex(
                      obj => obj.processing_index === currentProcessingIndex
                    ) + processingIndexModifier
                  let coords = [arr[index].long, arr[index].lat]
                  let imageryLayer
                  Object.entries(this.mmp_layersObj).forEach(layerArray => {
                    let layer = layerArray[1].layer
                    let layerGeoserverName = layer
                      .getSource()
                      .getParams().LAYERS
                    if (layerGeoserverName == this.activeImageryLayer) {
                      imageryLayer = layer
                    }
                  })
                  this.querySite(
                    {
                      coordinate: new transform(
                        coords,
                        'EPSG:4326',
                        'EPSG:3857'
                      )
                    },
                    imageryLayer,
                    this.map,
                    this.activeImageryLayer
                  )
                } else {
                  // No image(s) found in DB due to positive end of trail
                  this.$bvToast.toast(toastMsg, toastObj)
                }
              } else {
                this.$bvToast.toast(toastMsg, toastObj)
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          this.$router.push({ name: 'Login' })
        }
      } else if (newProcessingIndex >= 0) {
        if (this.ladybugImageryData.processingIndexLocationArray.length > 0) {
          // Image(s) found in DB
          let arr = this.ladybugImageryData.processingIndexLocationArray
          let index =
            arr.findIndex(
              obj => obj.processing_index === currentProcessingIndex
            ) + processingIndexModifier
          let coords = [arr[index].long, arr[index].lat]
          let imageryLayer
          Object.entries(this.mmp_layersObj).forEach(layerArray => {
            let layer = layerArray[1].layer
            let layerGeoserverName = layer.getSource().getParams().LAYERS
            if (layerGeoserverName == this.activeImageryLayer) {
              imageryLayer = layer
            }
          })
          this.querySite(
            { coordinate: new transform(coords, 'EPSG:4326', 'EPSG:3857') },
            imageryLayer,
            this.map,
            this.activeImageryLayer
          )
          this.getGSV(coords)
        } else {
          // No image(s) found in DB due to positive end of trail
          this.$bvToast.toast(toastMsg, toastObj)
        }
      } else {
        this.$bvToast.toast(toastMsg, toastObj)
      }
    },
    handlerClose() {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('pid')
    },
    getFeatureButtons(bool) {
      this.showFeatureButtons = bool
    },
    ansiTestingVisibility() {
      this.ansiTestingVisible = false
      this.intrsectionTestingVisible = false
    },
    /**
     * Added method to set ansiTestingVisible to false when Ansi testing modal is closed by close X button.
     */
    closeAnsiTestingWindow(){
     this.ansiTestingVisible = false
    },
    closeBiasedAnsiTestingWindow(){
     this.biasedTestingVisible = false
    },
    // replaceLidarAutoLoadDateCode(newDateCode) {
    //   this.autoLoadedLidarDateCode = this.featureTableLoadingLidar ? newDateCode : ''
    // },
    // resetAutoLoadingLidar() {
    //   this.featureTableLoadingLidar = false
    //   this.autoLoadedLidarDateCode = ''
    // },
    // REFACTOR SUGGESTION -- WEBGIS-2548 -- parameter unused.
    toggleLidarPanel(evt = null) {
      this.toggleLidarDownload()
      this.showLidarPanel = !this.showLidarPanel
      //reverted Lidar autoload code
      /* evt.visibility is only true when method is
      called from feature table event emission */
      // if (evt && evt.visibility) {
      //   this.map.getView().setZoom(19.5)
      //   this.map.getView().setCenter(evt.coords)
      //   this.getMapExtent()
      //   this.featureTableLoadingLidar = true
      //   this.lidarDownload(this)
      //   this.showLidarPanel = true
      //   this.setLidarMinZoomAchieved(true)
      // } else {
      //   this.toggleLidarDownload()
      //   this.showLidarPanel = !this.showLidarPanel
      // }
    },
    toggleLidarDownload() {
      // Lidar was off, turning it on
      if (!this.showLidarPanel) {
        this.getMapExtent()
        this.zoomEnded = this.map.getView().getZoom()
        this.setLidarMinZoomAchieved(this.zoomEnded >= 17)
        this.lidarDownload(this)
        this.onResizeLidar()
        // In home screen mode setListeners() isn't called, so wire reload listeners here
        if (this.homeScreenComponents) {
          this.olLidarMoveStartKey = this.map.on('movestart', () => {
            this.lidarIsLoading = true
          })
          this.olLidarMoveEndKey = this.map.on('moveend', () => {
            this.zoomEnded = this.map.getView().getZoom()
            this.setLidarMinZoomAchieved(this.zoomEnded >= 17)
            this.lidarDownload(this)
          })
        }
      } else {
        // Hide any lidar on map, clear distinct_lidar arr
        this.clearLidar()
        if (this.olLidarMoveStartKey) {
          new unByKey(this.olLidarMoveStartKey)
          this.olLidarMoveStartKey = null
        }
        if (this.olLidarMoveEndKey) {
          new unByKey(this.olLidarMoveEndKey)
          this.olLidarMoveEndKey = null
        }
      }
    },
    clearLidar() {
      let lidarLayersToRemove = []
      // Get the lidar layers
      this.map.getLayers().forEach(layer => {
        let layerNameStr = layer.get('name')
          ? layer.get('name').toString()
          : null
        if (layerNameStr && layerNameStr.includes('lidar')) {
          lidarLayersToRemove.push(layer)
        }
      })
      // Remove the lidar layers
      lidarLayersToRemove.forEach(layer => {
        this.map.removeLayer(layer)
      })

      // Clear distinct lidar arr
      this.distinct_lidar = []

      // Remove home-screen lidar listeners if they exist
      if (this.olLidarMoveStartKey) {
        new unByKey(this.olLidarMoveStartKey)
        this.olLidarMoveStartKey = null
      }
      if (this.olLidarMoveEndKey) {
        new unByKey(this.olLidarMoveEndKey)
        this.olLidarMoveEndKey = null
      }
    },
    getMapExtent() {
      this.extentName = this.selectedExtent
        ? this.selectedExtent
        : JSON.parse(sessionStorage.Extent)
    },
    lidarDownload: async self => {
      // let time = new Date().getTime() // REFACTOR SUGGESTION -- WEBGIS-2548 -- this is never used.
      // Only check for lidar if at appropriate zoom level
      if (self.zoomEnded >= 17) {
        // Turn on Lidar spinner since no data has loaded
        self.lidarIsLoading = true

        // Calculate users view extent
        let extent = self.map.getView().calculateExtent(self.map.getSize())
        // Transform extent from OSM format to lat/lon coords
        // EPSG:3857 - 'This is projected coordinate system used for rendering maps in Google Maps, OpenStreetMap, etc.' https://epsg.io/3857
        // EPSG:4326 - 'Horizontal component of 3D system. Used by the GPS satellite navigation system and for NATO military geodetic surveying.' https://epsg.io/4326
        let userExtentBoxCoords = new transformExtent(
          extent,
          'EPSG:3857',
          'EPSG:4326'
        )
        let apiUrl
        switch (self.extentName) {
          case 'Japan':
            apiUrl = '/api/drt/available_lidar_japan'
            break
          case 'North America':
            apiUrl = '/api/drt/available_lidar'
            break
          case 'Europe':
            apiUrl = '/api/drt/available_lidar_europe'
            break
          case 'Middle East':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
          case 'Kuwait':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
          case 'Saudi Arabia':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
        }
        if (sessionStorage.token) {
          await axios
            .get(process.env.API_LOCATION + apiUrl, {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              // Four corners of users view
              params: {
                xmin: userExtentBoxCoords[0],
                ymin: userExtentBoxCoords[1],
                xmax: userExtentBoxCoords[2],
                ymax: userExtentBoxCoords[3]
              }
            })
            .then(response => {
              const content = response.data
              // If duplicate entry found, throw error and prevent submission
              if (content.errors) {
                console.log('API Call Error: ' + content.errors)
              } else {
                // Grab any expanded groups
                let expanded = []
                self.distinct_lidar.forEach(lidar => {
                  if (!lidar.groupIsCollapsed) {
                    expanded.push(lidar.dateCode)
                  }
                })
                // Clearing distinct lidar after the new call has been returned
                // reduces user interface interruption
                self.distinct_lidar = []

                content.forEach(lidar => {
                  // Checking if pointcloud ID needs more processing to remove prefix
                  // If pointcloud ID starts with a number, it does not need more processing
                  if (!isNaN(lidar.pc_id.charAt(0))) {
                    let dateCode = parseInt(lidar.pc_id).toString()

                    // Check if date code in pointcloud ID is distinct to group
                    if (
                      !self.distinct_lidar.some(e => e.dateCode == dateCode)
                    ) {
                      self.distinct_lidar.push({
                        dateCode: dateCode,
                        groupIsCollapsed: true,
                        pointcloudIDArr: []
                        // autoLoad: self.ansiComponent ? true : false
                      })
                    }

                    // Else pointcloud ID has leading char and underscore I.E. C_140610_151507_S1
                  } else {
                    // Split on underscore to isolate date code
                    let findDateCode = lidar.pc_id.split('_')
                    // Date code will be index one
                    let dateCode = findDateCode[1]

                    // Check if date code in pointcloud ID is distinct to group
                    if (
                      !self.distinct_lidar.some(e => e.dateCode == dateCode)
                    ) {
                      self.distinct_lidar.push({
                        dateCode: dateCode,
                        groupIsCollapsed: true,
                        pointcloudIDArr: []
                        //autoLoad: self.ansiComponent ? true : false
                      })
                    }
                  }
                })

                // Now that we have distinct lidar dates extracted in this.distinct_lidar, we can build sub nav
                content.forEach(lidar => {
                  // Checking if pointcloud ID needs more processing to remove prefix
                  // If pointcloud ID starts with a number, it does not need more processing
                  if (!isNaN(lidar.pc_id.charAt(0))) {
                    let dateCode = parseInt(lidar.pc_id).toString()

                    let index =
                      self.distinct_lidar[
                      self.distinct_lidar.findIndex(
                        x => x.dateCode == dateCode
                      )
                      ]

                    index.pointcloudIDArr.push(lidar.pc_id)

                    // Else pointcloud ID has leading char and underscore I.E. C_140610_151507_S1
                  } else {
                    // Split on underscore to isolate date code
                    let findDateCode = lidar.pc_id.split('_')
                    // Date code will be index one
                    let dateCode = findDateCode[1]

                    let index =
                      self.distinct_lidar[
                      self.distinct_lidar.findIndex(
                        x => x.dateCode == dateCode
                      )
                      ]

                    index.pointcloudIDArr.push(lidar.pc_id)
                  }
                })

                // Sort distinct_lidar array so newest lidar is in index 0 and displayed first in the lidar subnav buttons
                self.distinct_lidar.sort((a, b) => {
                  return parseInt(b.dateCode) - parseInt(a.dateCode)
                })

                // Re expand any previously expanded groups
                // For each lidar group, check if matches any item in expanded array we created
                self.distinct_lidar.forEach(lidar => {
                  expanded.forEach(expandedGroupDateCode => {
                    // If match between distinct lidar group and a group that was previously expanded, re expand group
                    if (expandedGroupDateCode == lidar.dateCode) {
                      lidar.groupIsCollapsed = false
                    }
                  })
                })
                // Turn off Lidar spinner now that data has loaded
                self.lidarIsLoading = false
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
        // Else user needs to zoom in further to access lidar
      } else {
        // Clear any lidar groups, since nothing is available at users current zoom
        self.distinct_lidar = []
        self.clearLidar()
        self.lidarIsLoading = false
      }
    },
    removeCurrentPositionsInterval() {
      clearInterval(this.getCurrentPositionsInterval)
      this.getCurrentPositionsInterval = null
    },
    removeTripsInterval() {
      clearInterval(this.getTripsInterval)
      this.getTripsInterval = null
    },
    getReleaseVersion() {
      if (sessionStorage.token) {
        axios
          .get(
            process.env.API_LOCATION + '/api/release_notes/checkReleaseVersion',
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: { id: this.user.org }
            }
          )
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('checkReleaseVersion API Call Error: ' + content.errors)
            } else {
              this.versionReleaseInfo = content[0]
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    closeUSV() {
      this.showUshrStreetView = false
      /* Resets the USV's positioning on close,
      helpful if user dragged USV off-screen */
      let usvElement = document.getElementById(
        'ushrStreetViewPanel'
      ).parentElement
      usvElement.removeAttribute('style')
    },
    closeLadybugSV() {
      this.showLadybugStreetView = false
      /* Resets the USV's positioning on close,
      helpful if user dragged USV off-screen */
      let usvElement = document.getElementById(
        'ladybugStreetViewPanel'
      ).parentElement
      usvElement.removeAttribute('style')
    },
    initGTPReportModal() {
      this.$bvModal.show('gtpReportModal')
    },
    setLayerLegendAspectRatio(dimensions) {
      this.layerLegendDimensions = dimensions
      this.onResizeMainMenuOrDLL()
    },
    // REFACTOR SUGGESTION -- WEBGIS-2548 -- unused parameter
    initIntersectionReports(ansiSelectedSelset) {
      this.$bvModal.show('reportsIntersectionModal')
    },
    toggleChange(bool) {
      if (bool) {
        this.pointVectorSource.clear()
        this.pointVectorSource.addFeature(this.pointFeature)
      } else {
        this.pointVectorSource.removeFeature(this.pointFeature)
      }
    },
    async addPoint(feature) {
      await this.pointVectorSource.clear()
      this.pointFeature = feature
      this.pointVectorSource.addFeature(feature)
    },
    async vehicleChangeExtent(extentName) {
      let newExtent = this.extentResponse.filter(ext => ext.extent_description == extentName)

      let extentValues = []
      let extentCenter = []
      /* Need to convert the string into array of numbers
      for passing to the transformExtent function. */
      newExtent[0].extent.split(',').forEach(element => {
        extentValues.push(element)
      })
      newExtent[0].extent_center.split(',').forEach(element => {
        extentCenter.push(element)
      })
      let view = new View({
        extent: new transformExtent(
          extentValues,
          new projGet('EPSG:4326'),
          new projGet('EPSG:3857')
        ),
        center: new transform(
          extentCenter,
          new projGet('EPSG:4326'),
          new projGet('EPSG:3857')
        ),
        constrainOnlyCenter: true,
        zoom: 5,
        minZoom: 3,
        multiWorld: true
      })

      await this.extentChanged({
        selectedExtent: newExtent[0].extent_description,
        view: view
      })
    },
    async zoomToVehicle({ vehicleName, newExtent }) {
      let url = 'https://geoserver-aws.ushrauto.com/geoserver/wfs'
      const params = {
        service: 'WFS',
        version: '1.1.0',
        request: 'GetFeature',
        typeName: 'mmp:current_positions',
        srsName: 'EPSG:4326',
        outputFormat: 'application/json',
        cql_filter: `vehicle_name LIKE '%${vehicleName}%'`,
        authkey: sessionStorage.token
      };

      let res = await axios.get(url, { params })
      if (res.data.features.length) {
        if (newExtent != this.selectedExtent) {
          await this.vehicleChangeExtent(newExtent)
          this.toggleLayerVisibility('Current Positions')
          this.toggleLayerVisibility('Trips')
        }

        let coords = res.data.features[0].geometry.coordinates
        let newCenter = new transform(coords, 'EPSG:4326', 'EPSG:3857')
        await this.map.getView().animate({ zoom: 18 }, { center: newCenter })

        // Close modal
        this.$bvModal.hide('fleetioVehiclesModal')
      } else {
        console.log('Current position not found for vehicle ' + vehicleName)
      }
    },
    zoomToSegment([x, y]) {
      if (x != null && y != null) {
        var coord = new transform([x, y], 'EPSG:4326', 'EPSG:3857')
        this.map.getView().setCenter(coord)
        this.map.getView().setZoom(19.5)
      }
    },
    baseMapsExpandChange(bool) {
      this.baseMapsOpen = bool
    },
    extentsExpandChange(bool) {
      this.extentsOpen = bool
    },
    generateNewToken() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/auth/renew_token', {
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            params: {
              id: this.user.id,
              org: this.user.org
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('renew API CALL ERROR: ' + content.errors)
              sessionStorage.removeItem('token')
            } else {
              sessionStorage.setItem('token', content.token)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    setSpeedLimitSegment(seg) {
      this.currentAnsiSegment = seg
      this.$refs.AnsiFeatureTableRef?.trackAnsiSegmentReview(seg)
    },
    toggleSlider() {
      this.showslider = !this.showslider
      if (!this.showslider) {
        this.map.removeLayer(this.mileageVectorLayer) // remove circle if toggled off
      } else {
        if (this.mileageVectorLayer) {
          this.map.addLayer(this.mileageVectorLayer) // re add circle when toggled back on
        }
      }
    },
    closeAnaAttTable() {
      this.showAnalyticsAttributes = false
      this.anaAttribResponse = null
      this.map.removeLayer(this.vectorLayer)
      this.vectorLayer = null
    },
    refreshUAC() {
      this.$refs.UACRef.initUAC();
    },
    sendErrorNotification(msg) {
      this.gmUsers = [872]
      this.gmUsers.forEach(user_id => {
        this.pushNotification({msg: msg, user_id: user_id})
      })
    },
    pushNotification(obj) {
        if (sessionStorage.token) {
          axios.post(
            `${process.env.API_LOCATION}/api/notifications/sendNotification`,
            {
              msg: obj.msg,
              to_user_id: obj.user_id
            },
            { headers: { 'x-auth-token': sessionStorage.token } }
          )
          .catch(function (error) {
            console.log(error)
          })
        }
    },
  },
  beforeDestroy() {
    // Re enable default body overflow
    document.body.style.overflow = 'visible'
    // Ensure the ANSI night-mode body class never lingers after teardown
    document.body.classList.remove('ansi-night-mode')
    window.removeEventListener('resize', this.onResize)
    if (this.getCurrentPositionsInterval) {
      this.removeCurrentPositionsInterval()
    }
    if (this.getTripsInterval) {
      this.removeTripsInterval()
    }
    if (this.tokenExpirationInterval) {
      clearInterval(this.tokenExpirationInterval)
      this.tokenExpirationInterval = null
    }
    if (this.mapResizeObserver) {
      this.mapResizeObserver.disconnect()
      this.mapResizeObserver = null
    }
  },
  computed: { 
    ...mapGetters(['globalUserRole','globalAllowedUserModules','globalIsUserAllowed', 'globalVerifyCurrentUserRole']),
    grouped() {
      // Categorize the HWDBC layers from db values
      const groups = {}
      this.highwayDBcloudLayersButtonsCtrl.forEach(item => {
        groups[item.subcategory] = groups[item.subcategory] || []
        groups[item.subcategory].push(item)
      })

      // Orders the buttons under each heading according to their info.order_number ranking
      for (let group in groups) {
        groups[group].sort((a, b) => {
          let aOrder = parseInt(a.link_object.info.order_number)
          let bOrder = parseInt(b.link_object.info.order_number)
          return aOrder - bOrder
        })
      }
      return groups
    }
  },
  created() {
    document.body.style.overflow = 'hidden'
    window.addEventListener('beforeunload', this.handlerClose)
    this.timeBeforeLogout = this.timeBeforeLogoutDefault
    this.timeBeforeInactivityWarning = this.timeBeforeInactivityWarningDefault
    this.inactivityStartTime = Date.now()
    let inactivity = setInterval(() => {
      this.inactivityDetection(inactivity);
    }, 1000);
    this.tokenExpirationInterval = setInterval(() => {
      // Checks how long until current token expires, generates new token if token is set to expire in <= 5min
      try {
        let decoded = jwtDecode(sessionStorage.token)
        if (decoded && decoded.exp) {
          let exp = new Date(decoded.exp * 1000)
          let seconds = exp - Date.now();
          this.tokenExp = Math.floor(seconds / 1000);
          if (this.tokenExp <= 300) {
            this.generateNewToken()
          }
        }
      } catch (err) {
        this.$router.push({name: 'Login'})
      }
    }, 60000)
  },
  watch: {
    ansiTestingVisible: function (newValue, oldValue) {
      this.onResizeANSITestingWindow()
      // Moves the ANSI Testing Window's grid-item box below the viewport
      this.layout.filter(e => e.i == 5)[0].y = newValue ? 2 : 100
    },
    homeScreenComponents: function (newValue, oldValue) {
      // Removes current positions interval when leaving home screen
      if (!newValue && this.getCurrentPositionsInterval) {
        this.removeCurrentPositionsInterval()
      }
    },
    // Night mode only applies to ANSI; clear it whenever ANSI is torn down so
    // the darkened styles don't linger into DRT/other tools or the dashboard.
    ansiComponent: function (newValue) {
      if (!newValue && this.nightMode) {
        this.nightMode = false
        document.body.classList.remove('ansi-night-mode')
      }
    }
  }
}
</script>
